{
	"dialog.ok": "OK",
	"dialog.cancel": "Cancelar",
	"dialog.confirm": "Aceptar",
	"dialog.close": "Cerrar",
	"dialog.import": "Importar",
	"dialog.save": "Guardar",
	"dialog.discard": "Descartar",
	"dialog.dontshowagain": "No volver a mostrar",
	"data.cube": "Cubo",
	"data.group": "Grupo",
	"data.texture": "Textura",
	"data.plugin": "Plugin",
	"data.preview": "Previsualización",
	"data.toolbar": "Barra de herramientas",
	"data.image": "Imagen",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "CMD",
	"keys.delete": "Eliminar",
	"keys.space": "Espacio",
	"keys.leftclick": "Click Izquierdo",
	"keys.middleclick": "Click central",
	"keys.rightclick": "Click Derecho",
	"keys.tab": "Tabulador",
	"keys.backspace": "Retroceso",
	"keys.enter": "Intro",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Teclado numérico %0",
	"keys.caps": "Bloq Mayús",
	"keys.menu": "Menú Contextual",
	"keys.left": "Izquierda",
	"keys.up": "Arriba",
	"keys.right": "Derecha",
	"keys.down": "Abajo",
	"keys.pageup": "Página arriba",
	"keys.pagedown": "Página abajo",
	"keys.plus": "Más",
	"keys.comma": "Coma",
	"keys.point": "Punto",
	"keys.minus": "Minúscula",
	"keys.cross": "Cruz",
	"keys.end": "Fin",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Impr. Pantalla",
	"keys.pause": "Pausa",
	"message.rotation_limit.title": "Límites de Rotación",
	"message.rotation_limit.message": "Las rotaciones están limitadas por Minecraft en un sólo eje y en incrementos de 22.5 grados. Rotar en un eje diferente quitará la rotación en otros ejes. Convierte el modelo a \"Modelo Libre\" si quieres modelar para otros propósitos y necesitas rotaciones libres.",
	"message.file_not_found.title": "Archivo no encontrado",
	"message.file_not_found.message": "Blockbench no pudo encontrar el archivo pedido. Asegúrate de que está guardado localmente y no en una nube.",
	"message.screenshot.title": "Captura de pantalla",
	"message.screenshot.clipboard": "Portapapeles",
	"message.screenshot.right_click": "Clic derecho o mantén presionado para copiar la captura de pantalla",
	"message.invalid_file.title": "Archivo no válido",
	"message.invalid_file.message": "No se pudo abrir el archivo del modelo: %0",
	"message.invalid_model.title": "Archivo de Modelo Inválido",
	"message.invalid_model.message": "Este archivo no contiene información de modelo válida.",
	"message.child_model_only.title": "Modelo Hijo Vacío",
	"message.child_model_only.message": "Este archivo es hijo de %0 y no contiene ningún modelo",
	"message.unsaved_textures.title": "Texturas sin guardar",
	"message.unsaved_textures.message": "Tu modelo tiene texturas sin guardar. Asegúrate de guardarlas en la carpeta correcta del paquete de recursos",
	"message.model_clipping.title": "Módelo muy grande",
	"message.model_clipping.message": "Tu modelo contiene %0 cubos que son más grandes que el límite de bloques establecido por Minecraft. Este modelo no funcionará en Minecraft.",
	"message.loose_texture.title": "Importar Textura",
	"message.loose_texture.message": "La texture importada no forma parte de un Resource Pack. Minecraft sólo puede cargar texturas dentro de una carpeta de textures en un Resource Pack cargado.",
	"message.loose_texture.change": "Cambiar directorio",
	"message.update_res.title": "Resolución de la textura",
	"message.update_res.message": "¿Quieres actualizar la resolución del proyecto a la resolución de esta textura? Dale clic a \"Cancelar\" si la textura tiene una resolución mayor a la normal.",
	"message.update_res.update": "Actualizar",
	"message.bedrock_overwrite_error.message": "Blockbench no puede combinar este modelo con un archivo viejo",
	"message.bedrock_overwrite_error.backup_overwrite": "Crear copia de seguridad y sobrescribir",
	"message.bedrock_overwrite_error.overwrite": "Sobrescribir",
	"message.close_warning.message": "¿Quiéres guardar tu modelo?",
	"message.close_warning.web": "Tu trabajo actual se perderá. ¿Estás seguro de que quieres salir?",
	"message.default_textures.title": "Texturas por defecto",
	"message.default_textures.message": "Selecciona la carpeta \"textures\" del paquete de recursos por defecto",
	"message.default_textures.detail": "Extrae el paquete de texturas por defecto del Minecraft jar o búscalo en Google y descárgalo. Después busca la carpeta \"textures\" y ábrela. Blockbench recordará esa localización y tratará de extraer las texturas desde ahí si no las puede encontrar en el paquete de texturas actual.",
	"message.default_textures.select": "Selecciona la carpeta \"textures\" por defecto",
	"message.image_editor.title": "Selecciona un editor de imágenes",
	"message.image_editor.file": "Seleccionar archivo...",
	"message.image_editor.exe": "Seleccionar el ejecutable de un editor de imágenes",
	"message.display_skin.title": "Skin de Minecraft",
	"message.display_skin.message": "Selecciona un archivo de una skin de tu ordenador o escribe el nombre de un jugador",
	"message.display_skin.upload": "Seleccionar Archivo",
	"message.display_skin.reset": "Restablecer",
	"message.invalid_plugin": "Archivo de plugin inválido, lee la Consola",
	"message.load_plugin_app": "¿Quieres permitir a este plugin que haga cambios a tu PC? Carga sólo plugins de personas en las que confíes.",
	"message.load_plugin_web": "¿Quieres cargar este plugin? Carga sólo plugins de personas en las que confíes.",
	"message.preset_no_info": "La plantilla no contiene información para este apartado",
	"message.restart_to_update": "Reinicie Blockbench para aplicar cambios",
	"message.save_file": "Guardado como %0",
	"dialog.project.title": "Proyecto",
	"dialog.project.name": "Nombre de Archivo",
	"dialog.project.parent": "Modelo Padre",
	"dialog.project.geoname": "Identificador del Modelo",
	"dialog.project.ao": "Oclusión Ambiental",
	"dialog.texture.title": "Textura",
	"dialog.texture.variable": "Variable",
	"dialog.texture.namespace": "Espacio del Nombre",
	"dialog.texture.folder": "Carpeta",
	"dialog.extrude.title": "Extruir imagen",
	"dialog.extrude.mode": "Modo de Escaneo",
	"dialog.extrude.mode.areas": "Areas",
	"dialog.extrude.mode.lines": "Líneas",
	"dialog.extrude.mode.columns": "Columnas",
	"dialog.extrude.mode.pixels": "Píxeles",
	"dialog.extrude.opacity": "Opacidad Mínima",
	"dialog.extrude.scan": "Escanear e Importar",
	"dialog.display_preset.title": "Crear Plantilla",
	"dialog.display_preset.message": "Selecciona los apartados que quieras guardar",
	"dialog.display_preset.create": "Crear",
	"dialog.select.title": "Seleccionar",
	"dialog.select.group": "En el Grupo Seleccionado",
	"dialog.select.name": "El Nombre Contiene",
	"dialog.select.random": "Oportunidad Aleatoria (%)",
	"dialog.select.select": "Seleccionar",
	"dialog.scale.title": "Reescalar Modelo",
	"dialog.scale.axis": "Ejes",
	"dialog.scale.clipping": "El modelo sobresale: Es demasiado grande para el espacio de trabajo",
	"dialog.scale.confirm": "Reescalar",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Instalado",
	"dialog.plugins.available": "Disponible",
	"dialog.plugins.install": "Instalar",
	"dialog.plugins.uninstall": "Desinstalar",
	"dialog.plugins.reload": "Recargar",
	"dialog.plugins.none_installed": "No hay plugins instalados",
	"dialog.plugins.none_available": "No hay plugins disponibles",
	"dialog.plugins.web_only": "Sólo para la página web",
	"dialog.plugins.app_only": "Sólo para el programa de escritorio",
	"dialog.plugins.author": "por %0",
	"dialog.create_texture.folder": "Carpeta",
	"dialog.create_texture.resolution": "Resolución",
	"dialog.input.title": "Entrada",
	"dialog.settings.settings": "Ajustes",
	"dialog.settings.keybinds": "Atajos de Teclado",
	"dialog.settings.about": "Acerca de",
	"layout.color.back": "Fondo",
	"layout.color.back.desc": "Fondos y cajas de entrada",
	"layout.color.dark": "Oscuro",
	"layout.color.dark.desc": "Fondo del espacio de trabajo",
	"layout.color.ui": "IU",
	"layout.color.ui.desc": "Color principal de la interfaz",
	"layout.color.bright_ui": "IU clara",
	"layout.color.bright_ui.desc": "Menús contextuales e información de herramientas",
	"layout.color.button": "Botón",
	"layout.color.button.desc": "Botones e interruptores",
	"layout.color.selected": "Seleccionado",
	"layout.color.selected.desc": "Pestañas y objectos seleccionados",
	"layout.color.border": "Borde",
	"layout.color.border.desc": "Borde de botones y cajas de entrada",
	"layout.color.accent": "Acento",
	"layout.color.accent.desc": "Deslizador y otros detalles",
	"layout.color.grid": "Cuadrícula",
	"layout.color.grid.desc": "Cuadrícula de previsualización 3D",
	"layout.color.text": "Texto",
	"layout.color.text.desc": "Texto normal",
	"layout.color.light": "Claro",
	"layout.color.light.desc": "Texto destacado",
	"layout.color.accent_text": "Acento del texto",
	"layout.color.accent_text.desc": "Texto sobre fondos con acento",
	"layout.font.main": "Fuente principal",
	"layout.font.headline": "Fuente para títulos",
	"about.version": "Versión:",
	"settings.category.general": "General",
	"settings.category.preview": "Previsualización",
	"settings.category.grid": "Cuadrícula",
	"settings.category.edit": "Editar",
	"settings.category.snapping": "Imán",
	"settings.category.defaults": "Por defecto",
	"settings.category.dialogs": "Diálogos",
	"settings.category.export": "Exportar",
	"settings.language": "Lenguaje",
	"settings.language.desc": "Lenguaje de Interfaz",
	"settings.backup_interval": "Intervalo de Respaldos",
	"settings.backup_interval.desc": "Intervalo de los respaldos automáticos en minutos",
	"settings.origin_size": "Marcador de Pivote",
	"settings.origin_size.desc": "Tamaño del marcador del punto de pivote",
	"settings.control_size": "Transformar el tamaño del artilugio",
	"settings.control_size.desc": "Tamaño del artilugio de transformación",
	"settings.display_skin": "Skin de Minecraft",
	"settings.display_skin.desc": "Skin usada para la referencia del modelo jugador",
	"settings.shading": "Sombreado",
	"settings.shading.desc": "Habilitar sombreado en vista previa",
	"settings.texture_fps": "FPS de las Texturas Animadas",
	"settings.texture_fps.desc": "Cuadros por segundo para texturas animadas",
	"settings.base_grid": "Cuadrícula Pequeña",
	"settings.base_grid.desc": "Mostrar cuadrícula y ejes pequeños",
	"settings.large_grid": "Cuadrícula de bloques",
	"settings.large_grid.desc": "Mostrar cuadrícula de 16x16 bloques",
	"settings.full_grid": "Cuadrícula de bloques precisa",
	"settings.full_grid.desc": "Mostrar cuadrícula de bloques con precisión de píxeles",
	"settings.large_box": "Caja con límite de tamaño",
	"settings.large_box.desc": "Mostrar límites de tamaño",
	"settings.display_grid": "Modo de Visualización Cuadrícula",
	"settings.display_grid.desc": "Mostrar cuadrícula en el modo de visualización",
	"settings.undo_limit": "Límite de deshacer",
	"settings.undo_limit.desc": "Número de acciones que puedes deshacer",
	"settings.local_move": "Mover en Ejes Relativos",
	"settings.local_move.desc": "Mover elementos rotados en sus propios ejes si es posible",
	"settings.canvas_unselect": "Deselección con Click en el Espacio de Trabajo",
	"settings.canvas_unselect.desc": "Deseleccionar todos los elementos cuando se hace click en el fondo del espacio de trabajo",
	"settings.paint_side_restrict": "Restringir el pincel a los lados",
	"settings.paint_side_restrict.desc": "Restringir los pinceles para sólo pintar en el lado actual",
	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Activar Auto UV por defecto",
	"settings.create_rename": "Renombrar Nuevo Elemento",
	"settings.create_rename.desc": "Campo de nombre de enfoque al crear nuevo elemento o grupo",
	"settings.edit_size": "Resolución de la Cuadrícula",
	"settings.edit_size.desc": "Resolución de la cuadrícula a la que se ajustan los elementos",
	"settings.shift_size": "Resolución de Shift",
	"settings.shift_size.desc": "Resolución de la cuadrícula al mantener Shift",
	"settings.ctrl_size": "Resolución de Control",
	"settings.ctrl_size.desc": "Resolución de la cuadrícula al mantener Control",
	"settings.negative_size": "Tamaño Negativo",
	"settings.negative_size.desc": "Permitir a la herramienta de reescalado usar tamaños negativos",
	"settings.minifiedout": "Exportación minimizada",
	"settings.minifiedout.desc": "Escribir archivos JSON en una línea",
	"settings.export_groups": "Exportar Grupos en modelos item/bloque de Java",
	"settings.export_groups.desc": "Guardar grupos en archivos JSON de bloques java o modelos de item",
	"settings.credit": "Comentario de Créditos",
	"settings.credit.desc": "Añadir un comentario de créditos a archivos exportados",
	"settings.default_path": "Directorio por defecto de las texturas de Minecraft",
	"settings.default_path.desc": "Carpeta desde donde Blockbench carga las texturas por defecto",
	"settings.image_editor": "Editor de Imágenes",
	"settings.image_editor.desc": "Editor de imágenes por defecto con el que editar las texturas",
	"category.navigate": "Navegación",
	"category.tools": "Herramientas",
	"category.file": "Archivo",
	"category.blockbench": "Blockbench",
	"category.edit": "Editar",
	"category.transform": "Transformar",
	"category.view": "Ver",
	"category.display": "Ajustes de visualización",
	"category.textures": "Texturas",
	"category.misc": "Misceláneo",
	"keybind.preview_select": "Seleccionar",
	"keybind.preview_rotate": "Vista de Rotación",
	"keybind.preview_drag": "Vista de Arrastre",
	"keybind.confirm": "Confirmar",
	"keybind.cancel": "Cancelar",
	"action.slider_inflate": "Inflar",
	"action.slider_inflate.desc": "Inflar cubos en todas las direcciones sin cambiar el UV",
	"action.slider_brush_size": "Tamaño",
	"action.slider_brush_size.desc": "Radio del pincel en píxeles",
	"action.slider_brush_opacity": "Opacidad",
	"action.slider_brush_opacity.desc": "Opacidad del pincel de 0 a 255",
	"action.slider_brush_softness": "Suavidad",
	"action.slider_brush_softness.desc": "Suavidad del pincel en porcentaje",
	"action.uv_slider_pos_x": "Mover Horizontal",
	"action.uv_slider_pos_x.desc": "Mover horizontalmente todas las caras UV seleccionadas",
	"action.uv_slider_pos_y": "Mover Vertical",
	"action.uv_slider_pos_y.desc": "Mover verticalmente todas las caras UV seleccionadas",
	"action.uv_slider_size_x": "Tamaño Horizontal",
	"action.uv_slider_size_x.desc": "Redimensionar horizontalmente todas las caras UV seleccionadas",
	"action.uv_slider_size_y": "Tamaño Vertical",
	"action.uv_slider_size_y.desc": "Redimensionar verticalmente todas las caras UV seleccionadas",
	"action.vertex_snap_mode": "Modo Imán",
	"action.vertex_snap_mode.desc": "Seleccionar si el Imán para Vertices mueve los elementos a la posición seleccionada o si los reescala",
	"action.move_tool": "Mover",
	"action.move_tool.desc": "Herramienta para seleccionar y mover elementos",
	"action.resize_tool": "Reescalar",
	"action.resize_tool.desc": "Herramienta para seleccionar y reescalar elementos",
	"action.brush_tool": "Pincel de pintura",
	"action.brush_tool.desc": "Pincel de color para dibujar sobre texturas",
	"action.vertex_snap_tool": "Imán para Vértices",
	"action.vertex_snap_tool.desc": "Mover un cubo a otro cubo al conectar 2 vértices",
	"action.swap_tools": "Cambiar Herramientas",
	"action.swap_tools.desc": "Cambiar entre la herramienta para mover y para reescalar",
	"action.project_window": "Proyecto...",
	"action.project_window.desc": "Abre la ventana del proyecto, donde puedes cambiar la metadata de tu modelo",
	"action.open_model": "Abrir Modelo",
	"action.open_model.desc": "Abre un archivo de modelo de tu ordenador",
	"action.extrude_texture": "Textura Extruida",
	"action.extrude_texture.desc": "General un modelo al extender una textura",
	"action.export_blockmodel": "Exportar modelo de bloque/item",
	"action.export_blockmodel.desc": "Exportar un modelo de bloque o de item de Minecraft Java Edition",
	"action.export_optifine_part": "Exportar Parte de Optifine",
	"action.export_optifine_part.desc": "Exportar una sola parte para un modelo de entidad de OptiFine",
	"action.export_optifine_full": "Exportar a OptiFine JEM",
	"action.export_optifine_full.desc": "Exportar un modelo completo de entidad de OptiFine",
	"action.export_obj": "Exportar Modelo OBJ",
	"action.export_obj.desc": "Exportar un modelo Wavefront OBJ para su renderización",
	"action.settings_window": "Ajustes...",
	"action.settings_window.desc": "Abre la ventana de ajustes de Blockbench",
	"action.plugins_window": "Plugins...",
	"action.plugins_window.desc": "Abre la ventana de la tienda de plugins",
	"action.reset_layout": "Resetear Diseño",
	"action.reset_layout.desc": "Resetea el diseño al que tiene Blockbench por defecto",
	"action.load_plugin": "Cargar Plugin desde Archivo",
	"action.load_plugin.desc": "Carga un plugin importando el archivo base",
	"action.reload_plugins": "Recargar Plugins",
	"action.reload_plugins.desc": "Recarga todos los plugins en desarrollo.",
	"action.undo": "Deshacer",
	"action.undo.desc": "Deshace el último cambio",
	"action.redo": "Rehacer",
	"action.redo.desc": "Rehace el último cambio",
	"action.copy": "Copiar",
	"action.copy.desc": "Copia la selección, cara o ajustes de visualización",
	"action.paste": "Pegar",
	"action.paste.desc": "Pega la selección, cara o ajustes de visualización",
	"action.cut": "Cortar",
	"action.cut.desc": "Corta la selección, cara o ajustes de visualización",
	"action.add_cube": "Añadir Cubo",
	"action.add_cube.desc": "Añade un nuevo cubo",
	"action.add_group": "Añadir Grupo",
	"action.add_group.desc": "Añade un nuevo grupo o hueso",
	"action.outliner_toggle": "Activar Más Opciones",
	"action.outliner_toggle.desc": "Cambia los botones para más opciones en el Esquema",
	"action.duplicate": "Duplicar",
	"action.duplicate.desc": "Duplica los elementos o el grupo seleccionados",
	"action.delete": "Borrar",
	"action.delete.desc": "Elimina los elementos o el grupo seleccionados",
	"action.sort_outliner": "Ordenar Esquema",
	"action.sort_outliner.desc": "Ordena el esquema alfabéticamente",
	"action.select_window": "Seleccionar...",
	"action.select_window.desc": "Busca y seleccionar elementos basados en sus propiedades",
	"action.invert_selection": "Invertir Selección",
	"action.invert_selection.desc": "Invertir la selección actual de elementos",
	"action.select_all": "Seleccionar Todo",
	"action.select_all.desc": "Selecciona todos los elementos, caras, vértices, o fotogramas",
	"action.collapse_groups": "Colapsar Grupos",
	"action.collapse_groups.desc": "Contraer todos los grupos del esquema",
	"action.scale": "Reescalar...",
	"action.scale.desc": "Escalar los elementos seleccionados",
	"action.toggle_visibility": "Cambiar Visibilidad",
	"action.toggle_visibility.desc": "Cambiar la visibilidad de los elementos seleccionados",
	"action.toggle_export": "Cambiar Exportación",
	"action.toggle_export.desc": "Cambia el ajuste de exportación de los elementos seleccionados",
	"action.toggle_autouv": "Cambiar Auto UV",
	"action.toggle_autouv.desc": "Cambia el ajuste de Auto UV de los elementos seleccionados",
	"action.toggle_shade": "Cambiar Sombreado",
	"action.toggle_shade.desc": "Cambia el ajuste de sombreado de los elementos seleccionados",
	"action.rename": "Renombrar",
	"action.rename.desc": "Cambia el nombre de los elementos seleccionados",
	"action.add_display_preset": "Nueva Plantilla",
	"action.add_display_preset.desc": "Añadir un nuevo pre-ajuste de visualización",
	"action.fullscreen": "Pantalla Completa",
	"action.fullscreen.desc": "Cambia el modo de pantalla completa",
	"action.zoom_in": "Hacer zoom",
	"action.zoom_in.desc": "Hace zoom para hacer la interfaz más grande",
	"action.zoom_out": "Quitar zoom",
	"action.zoom_out.desc": "Quita zoom para hacer la interfaz más pequeña",
	"action.zoom_reset": "Resetear Zoom",
	"action.zoom_reset.desc": "Reseta el zoom al 100% por defecto.",
	"action.reset_interface": "Resetar Interfaz",
	"action.reset_interface.desc": "Resetea el tamaño y las posiciones de la Interfaz.",
	"action.screenshot_model": "Captura de Pantalla del Modelo",
	"action.screenshot_model.desc": "Toma una captura de pantalla recortada del modelo desde el ángulo actual",
	"action.screenshot_app": "Captura de Pantalla de la Aplicación",
	"action.screenshot_app.desc": "Hace una captura de pantalla de toda la aplicación",
	"action.import_texture": "Importar Textura",
	"action.import_texture.desc": "Importa una o más texturas de tu sistema de archivos",
	"action.create_texture": "Crear Textura",
	"action.create_texture.desc": "Crea una textura en blanco o para una plantilla",
	"action.save_textures": "Guardar Texturas",
	"action.save_textures.desc": "Guarda todas las texturas que no han sido guardadas",
	"action.animated_textures": "Activar Texturas Animadas",
	"action.animated_textures.desc": "Activa y pone en pausa la previsualización de las texturas animadas",
	"action.origin_to_geometry": "Centrar Pivote",
	"action.origin_to_geometry.desc": "Pone el punto de pivote al centro de la selección",
	"action.rescale_toggle": "Cambiar Reescalado",
	"action.rescale_toggle.desc": "Reescalar cubos basándonse en su rotación actual",
	"action.bone_reset_toggle": "Resetear Hueso",
	"action.bone_reset_toggle.desc": "Impide que el hueso muestre cubos del modelo padre",
	"action.reload": "Recargar Blockbench",
	"action.reload.desc": "Reinicia Blockbench. Esto borrará todo el progreso no guardado",
	"menu.file": "Archivo",
	"menu.edit": "Editar",
	"menu.transform": "Transformar",
	"menu.display": "Visualización",
	"menu.view": "Ver",
	"menu.file.new": "Nuevo",
	"menu.file.recent": "Reciente",
	"menu.file.import": "Importar",
	"menu.file.export": "Exportar",
	"menu.transform.rotate": "Rotar",
	"menu.transform.flip": "Invertir",
	"menu.transform.center": "Centrar",
	"menu.transform.properties": "Propiedades",
	"menu.display.preset": "Aplicar Plantilla",
	"menu.display.preset_all": "Aplicar Plantilla en Todo",
	"menu.display.remove_preset": "Borrar Plantilla",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Fondo",
	"menu.view.screenshot": "Captura de Pantalla",
	"menu.cube.color": "Color",
	"menu.cube.texture": "Textura",
	"menu.cube.texture.transparent": "Transparente",
	"menu.cube.texture.blank": "En Blanco",
	"menu.group.sort": "Ordenar",
	"menu.texture.face": "Aplicar a Cara",
	"menu.texture.file": "Archivo",
	"menu.texture.refresh": "Refrescar",
	"menu.texture.change": "Cambiar Archivo",
	"menu.texture.folder": "Mostrar en el Explorador de archivos",
	"menu.texture.edit": "Editar",
	"menu.texture.export": "Guardar Como",
	"menu.texture.save": "Guardar",
	"menu.texture.properties": "Propiedades",
	"menu.preview.background": "Fondo",
	"menu.preview.background.load": "Cargar",
	"menu.preview.background.position": "Posición",
	"menu.preview.background.lock": "Fijar a la Cámara",
	"menu.preview.screenshot": "Captura de Pantalla",
	"menu.preview.perspective": "Perspectiva",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Vista Cuádruple",
	"menu.preview.stop_drag": "Parar la Colocación del Fondo",
	"menu.uv.mapping.rotation": "Rotación",
	"menu.uv.texture": "Textura",
	"cube.color.light_blue": "Azul claro",
	"cube.color.yellow": "Amarillo",
	"cube.color.orange": "Naranja",
	"cube.color.red": "Rojo",
	"cube.color.purple": "Morado",
	"cube.color.blue": "Azul",
	"cube.color.green": "Verde",
	"cube.color.lime": "Lima",
	"switches.visibility": "Visibilidad",
	"switches.export": "Exportar",
	"switches.autouv": "Auto UV",
	"panel.uv": "UV",
	"panel.display": "Visualización",
	"panel.textures": "Texturas",
	"panel.outliner": "Esquema",
	"uv_editor.title": "Editor de UV",
	"uv_editor.all_faces": "Todo",
	"uv_editor.no_faces": "Ninguno",
	"face.north": "Norte",
	"face.south": "Sur",
	"face.west": "Oeste",
	"face.east": "Este",
	"face.up": "Arriba",
	"face.down": "Abajo",
	"direction.north": "Norte",
	"direction.south": "Sur",
	"direction.west": "Oeste",
	"direction.east": "Este",
	"direction.top": "Arriba",
	"direction.bottom": "Abajo",
	"display.slot.third_right": "Tercera Persona, Derecha",
	"display.slot.third_left": "Tercera Persona, Izquierda",
	"display.slot.first_right": "Primera Persona, Derecha",
	"display.slot.first_left": "Primera Persona, Izquierda",
	"display.slot.head": "Cabeza",
	"display.slot.ground": "Suelo",
	"display.slot.frame": "Marco",
	"display.slot.gui": "Interfaz",
	"display.rotation": "Rotación",
	"display.translation": "Translación",
	"display.scale": "Reescalado",
	"display.slot": "Apartado",
	"display.reference": "Modelo de Referencia",
	"display.reference.player": "Jugador",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Armor Stand",
	"display.reference.baby_zombie": "Zombie bebé",
	"display.reference.armor_stand_small": "Armor Stand Pequeño",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Arco Cargado",
	"display.reference.block": "Bloque",
	"display.reference.frame": "Marco de Ítems",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventario",
	"display.reference.hud": "Interfaz",
	"display.preset.blank_name": "Por favor, introduce un nombre",
	"display.preset.item": "Ítem por defecto",
	"display.preset.block": "Bloque por defecto",
	"display.preset.handheld": "Arma por defecto",
	"display.preset.rod": "Palo por defecto",
	"dialog.continue": "Continuar",
	"message.square_textures": "Las texturas tienen que ser cuadradas",
	"message.unsaved_texture.title": "Textura sin guardar",
	"message.unsaved_texture.message": "Todos los cambios no guardados de esta textura serán perdidos. ¿Quieres continuar?",
	"action.vertex_snap_mode.move": "Mover",
	"action.vertex_snap_mode.scale": "Reescalar",
	"action.open_model_folder": "Abrir la Carpeta del Modelo",
	"action.open_model_folder.desc": "Abre la carpeta que contiene al modelo dentro",
	"action.change_textures_folder": "Cambiar Localización de las Texturas",
	"action.change_textures_folder.desc": "Cambia la carpeta que en la que se guardan todas las texturas",
	"menu.texture.particle": "Usar para Partículas",
	"message.update_notification.title": "No fue posible Instalar la Actualización",
	"message.update_notification.message": "Una nueva versión de Blockbench está disponible. ¡Active Actualizaciones Automáticas para actualizar!",
	"message.untextured": "La superficie no tiene una textura",
	"dialog.toolbar_edit.title": "Personalizar Barra de Herramientas",
	"keybindings.reset": "Resetear",
	"keybindings.clear": "Vacío",
	"action.cube_counter": "Estadísticas del Modelo",
	"action.uv_rotation": "Rotación del UV",
	"action.uv_rotation.desc": "Rotación de la cara del UV",
	"action.uv_grid": "Cuadrícula del UV",
	"action.uv_grid.desc": "La resolución de la cuadrícula a la que el selector del UV se engancha",
	"action.uv_grid.auto": "Automático",
	"action.uv_maximize": "Maximizar UV",
	"action.uv_maximize.desc": "Configura el UV para esta cara a la textura completa",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Configura el tamaño del UV de esta cara al tamaño real de la propia cara",
	"action.uv_rel_auto": "Auto UV Relativo",
	"action.uv_rel_auto.desc": "Configura el UV de esta cara a la posición y tamaño de la propia cara",
	"action.uv_mirror_x": "Invertir UV en X",
	"action.uv_mirror_x.desc": "Invierte el UV de esta cara en el eje X",
	"action.uv_mirror_y": "Invertir UV en Y",
	"action.uv_mirror_y.desc": "Invierte el UV de esta cara en el eje Y",
	"action.uv_transparent": "Eliminar cara",
	"action.uv_transparent.desc": "Convierte la cara actual en transparente",
	"action.uv_reset": "Resetear Cara",
	"action.uv_reset.desc": "Resetea la cara actual",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Deshabilita el renderizado para esta cara si el lado seleccionado del modelo está cubierto",
	"action.auto_cullface": "Auto Cullface",
	"action.auto_cullface.desc": "Configura el cullface para esta cara a sí mismo",
	"action.face_tint": "Tintar",
	"action.face_tint.desc": "Habilita la opción de tintado para la cara actual",
	"menu.toolbar.edit": "Personalizar",
	"menu.toolbar.reset": "Resetear",
	"uv_editor.rotated": "Rotado",
	"uv_editor.auto_cull": "Cullface a sí Mismo",
	"uv_editor.copied": "Cara Copiada",
	"uv_editor.pasted": "Cara Pegada",
	"uv_editor.copied_x": "Copiadas %0 Caras",
	"uv_editor.reset": "Resetear Cara",
	"uv_editor.maximized": "Maximizada",
	"uv_editor.autouv": "Tamaño Automático",
	"uv_editor.mirrored": "Invertida",
	"uv_editor.to_all": "Aplicar a Todas Las Caras",
	"uv_editor.transparent": "Hecho transparente",
	"uv_editor.cullface_on": "Cullface Activado",
	"uv_editor.cullface_off": "Cullface Desactivado",
	"uv_editor.tint_on": "Tintar Activado",
	"uv_editor.tint_off": "Tintar Desactivado",
	"action.uv_apply_all": "Aplicar a Todas las Caras",
	"action.uv_apply_all.desc": "Aplica los ajustes de la cara actual a todas las caras",
	"message.image_editor_missing.title": "Editor de Imágenes por Defecto",
	"message.image_editor_missing.message": "Selecciona el archivo ejecutable de tu editor de imágenes.",
	"message.image_editor_missing.detail": "Blockbench no pudo encontrar un editor de imágenes en tu ordenador. Selecciona el archivo ejecutable de tu editor de imágenes preferido.",
	"action.update_autouv": "Actualizar Auto UV",
	"action.update_autouv.desc": "Actualiza el mapeado del auto UV en los cubos seleccionados",
	"category.uv": "UV",
	"status_bar.saved": "El modelo está guardado",
	"status_bar.unsaved": "Hay cambios sin guardar",
	"action.move_up": "Mover Hacia Arriba",
	"action.move_up.desc": "Mueve los cubos seleccionados hacia arriba relativo al ángulo actual de la cámara",
	"action.move_down": "Mover Hacia Abajo",
	"action.move_down.desc": "Mueve los cubos seleccionados hacia abajorelativo al ángulo actual de la cámara",
	"action.move_left": "Mover Hacia Izquierda",
	"action.move_left.desc": "Mueve los cubos seleccionados hacia la izquierda relativo al ángulo actual de la cámara",
	"action.move_right": "Mover Hacia Derecha",
	"action.move_right.desc": "Mueve los cubos seleccionados hacia la derecha relativo al ángulo actual de la cámara",
	"action.move_forth": "Mover Hacia Delante",
	"action.move_forth.desc": "Mueva los elementos seleccionados hacia adelante en relación con el ángulo actual de la cámara",
	"action.move_back": "Mover Hacia Atrás",
	"action.move_back.desc": "Mueve los cubos seleccionados hacia atrás relativo al ángulo actual de la cámara",
	"layout.color.wireframe": "Estructura",
	"layout.color.wireframe.desc": "Líneas de vista de la estructura",
	"action.add_animation": "Añadir Animación",
	"action.add_animation.desc": "Crear Animación Vacía",
	"action.load_animation_file": "Importar Animaciones",
	"action.load_animation_file.desc": "Importa un archivo de animación",
	"action.play_animation": "Mostrar Animaciones",
	"action.play_animation.desc": "Previsualiza la animación seleccionada",
	"action.slider_keyframe_time": "Código de tiempo",
	"action.slider_keyframe_time.desc": "Cambia el código de tiempo de los frames clave seleccionados",
	"timeline.rotation": "Rotación",
	"timeline.position": "Posición",
	"timeline.scale": "Escala",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Animaciones",
	"panel.keyframe": "Fotograma Clave",
	"panel.keyframe.type": "Fotograma Clave (%0)",
	"generic.delete": "Eliminar",
	"generic.rename": "Renombrar",
	"message.no_animation_selected": "Tienes que seleccionar una animación para hacer esto",
	"message.no_bone_selected": "Tienes que seleccionar un hueso para hacer esto",
	"message.duplicate_groups.title": "Duplicar Nombre del Hueso",
	"message.duplicate_groups.message": "El nombre de este hueso existe en varios huesos. Esto puede causar problemas",
	"action.delete_keyframes": "Eliminar Fotogramas Clave",
	"action.delete_keyframes.desc": "Elimina todos los fotogramas clave seleccionados",
	"menu.animation": "Animación",
	"menu.animation.loop": "Modo de bucle",
	"menu.animation.override": "Sobreescribir",
	"menu.animation.anim_time_update": "Actualizar Variable",
	"message.display_skin_model.title": "Modelo de Skin",
	"message.display_skin_model.message": "Escoge el tipo de modelo de tu skin",
	"message.display_skin_model.classic": "Clásico",
	"message.display_skin_model.slim": "Delgado",
	"message.bone_material": "Cambiar el material del hueso",
	"action.slider_animation_length": "Duración de la Animación",
	"action.slider_animation_length.desc": "Cambia la duración de la animación seleccionada",
	"panel.variable_placeholders": "Variables Temporales",
	"panel.variable_placeholders.info": "Muestra las variables que quieres visualizar mediante nombre=valor",
	"status_bar.vertex_distance": "Distancia: %0",
	"dialog.create_gif.title": "Grabar GIF",
	"dialog.create_gif.length": "Duración",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Reproducir Animación",
	"category.animation": "Animación",
	"action.record_model_gif": "Grabar GIF...",
	"action.record_model_gif.desc": "Graba un GIF animado de este modelo desde este ángulo",
	"display.mirror": "Invertir",
	"data.separator": "Separador",
	"menu.preview.background.set_position": "Ajustar Posición",
	"dialog.toolbar_edit.hidden": "Oculto",
	"action.export_class_entity": "Exportar Entidad de Java",
	"action.export_class_entity.desc": "Exporta el modelo de entidad como una clase de Java",
	"settings.seethrough_outline": "Bordes Rayos-X",
	"settings.seethrough_outline.desc": "Mostrar los bordes a través de los objetos",
	"mode.edit": "Editar",
	"mode.paint": "Pintar",
	"mode.display": "Mostrar",
	"mode.animate": "Animar",
	"status_bar.recording_gif": "Grabando",
	"status_bar.processing_gif": "Procesando",
	"settings.backup_retain": "Mantenimiento de Respaldos",
	"settings.backup_retain.desc": "Ajustar cuanto tiempo Blockbench mantiene respaldos viejos en días",
	"action.rotate_tool": "Rotar",
	"action.rotate_tool.desc": "Herramienta para seleccionar y rotar elementos",
	"action.fill_tool": "Cubo de Pintura",
	"action.fill_tool.desc": "Herramienta para rellenar caras enteras con un color",
	"action.eraser": "Borrador",
	"action.eraser.desc": "Herramienta para reemplazar colores en una textura por transparencia",
	"action.color_picker": "Seleccionador de Color",
	"action.color_picker.desc": "Herramienta para seleccionar el color de píxeles en tu textura",
	"switches.mirror": "Invertir UV",
	"language_name": "Español",
	"message.plugin_reload": "Recargados %0 plugins locales",
	"settings.brightness": "Brillo",
	"settings.brightness.desc": "Brillo de la previsualización. Por defecto es 50",
	"menu.preview.perspective.reset": "Resetear Cámara",
	"action.fill_mode": "Modo de Llenado",
	"action.fill_mode.face": "Cara",
	"action.fill_mode.color": "Colores",
	"action.toggle_mirror_uv": "Invertir UV",
	"action.toggle_mirror_uv.desc": "Activa el invertido de UV en el eje X de los cubos seleccionados",
	"menu.texture.blank": "Aplicar a Caras sin Textura",
	"dialog.scale.select_overflow": "Seleccionar Overflow",
	"action.action_control": "Control de Acción",
	"action.action_control.desc": "Busca y ejecuta cualquier acción disponible",
	"keybindings.recording": "Anotando Atajo de Teclado",
	"keybindings.press": "Pulsa una tecla o una combinación de teclas o haz click en cualquier lugar de tu pantalla para anotar el atajo de teclado",
	"action.pivot_tool": "Herramienta de Pivote",
	"action.pivot_tool.desc": "Herramienta para cambiar el punto de pivote de cubos y huesos",
	"action.slider_animation_speed": "Velocidad de Playback",
	"action.slider_animation_speed.desc": "Velocidad de playback del línea de tiempo en porcentaje",
	"action.previous_keyframe": "Fotograma Clave Anterior",
	"action.previous_keyframe.desc": "Salta al fotograma clave anterior",
	"action.next_keyframe": "Fotograma Clave Siguiente",
	"action.next_keyframe.desc": "Salta al fotograma clave siguiente",
	"message.outdated_client.title": "Programa desactualizado",
	"message.outdated_client.message": "Por favor actualiza a la última versión de Blockbench para hacer esto.",
	"action.export_asset_archive": "Descargar Archivo",
	"action.export_asset_archive.desc": "Descarga un archivo con el modelo y todas las texturas en él",
	"action.upload_sketchfab": "Subir a Sketchfab",
	"message.sketchfab.name_or_token": "Por favor, introduce tu token de Sketchfab y un nombre",
	"dialog.sketchfab_uploader.title": "Subir Modelo de Sketchfab",
	"dialog.sketchfab_uploader.token": "Token de API",
	"dialog.sketchfab_uploader.about_token": "El token es usado para conectar Blockbench a tu cuenta de Sketchfab. Puedes encontrarlo en %0",
	"dialog.sketchfab_uploader.name": "Nombre del Modelo",
	"dialog.sketchfab_uploader.description": "Descripción",
	"dialog.sketchfab_uploader.tags": "Etiquetas",
	"settings.sketchfab_token": "Token de Sketchfab",
	"settings.sketchfab_token.desc": "Token para autorizar a Blockbench a subir a tu cuenta de Sketchfab",
	"panel.color": "Color",
	"data.origin": "Pivote",
	"message.sketchfab.success": "Modelo subido con éxito",
	"message.sketchfab.error": "La subida del modelo a Sketchfab ha fallado",
	"settings.outliner_colors": "Colores del Borde",
	"settings.outliner_colors.desc": "Muestra los colores de cubo en el borde",
	"action.upload_sketchfab.desc": "Subir tu modelo a Sketchfab",
	"action.element_colors": "Colores de Cubo",
	"action.element_colors.desc": "Muestra los colores de cubo en el borde",
	"texture.error.file": "Archivo no encontrado",
	"texture.error.parent": "Archivo de textura proveído por el modelo padre",
	"message.recover_backup.title": "Recuperar Modelos",
	"message.recover_backup.message": "Blockbench fue cerrado sin guardar. ¿Quieres recuperar el modelo?",
	"message.invalid_session.title": "Token de Sesión Inválido",
	"message.invalid_session.message": "La sesión a la que estas intentando entrar ha expirado o el token proveído es inválido.",
	"dialog.create_texture.power": "Tamaño Al Cuadrado",
	"dialog.create_gif.turn": "Velocidad del Tocadiscos",
	"action.edit_session": "Editar sesión...",
	"action.edit_session.desc": "Conectarse a una sesión de edición para colaborar con otros usuarios",
	"action.reset_keyframe": "Resetear Fotogramas Clave",
	"action.reset_keyframe.desc": "Resetea todos los valores de los fotogramas clave seleccionados",
	"dialog.edit_session.title": "Editar Sesión",
	"edit_session.username": "Nombre de Usuario",
	"edit_session.token": "Token",
	"edit_session.about": "Editar Sesiones puede ser utilizado para colaborar en modelos a través de Internet. Crea una sesión, copia el token y mándaselo a amigos, los cuales lo pueden usar para entrar.",
	"edit_session.join": "Entrar a Sesión",
	"edit_session.create": "Crear Sesión",
	"edit_session.quit": "Salir de Sesión",
	"edit_session.joined": "%0 ha entrado a la sesión",
	"edit_session.left": "%0 ha salido de la sesión",
	"edit_session.quit_session": "Salir de la sesión actual",
	"edit_session.status": "Estado",
	"edit_session.hosting": "Anfitrión",
	"edit_session.connected": "Conectado a una sesión",
	"dialog.sketchfab_uploader.private": "Privado (Pro)",
	"dialog.sketchfab_uploader.password": "Contraseña (Pro)",
	"action.uv_select_all": "Seleccionar Todos",
	"action.uv_select_all.desc": "Selecciona todas las caras en el diálogo del UV",
	"panel.chat": "Chat",
	"edit_session.welcome": "Bienvenido a esta sesión por %0",
	"dialog.yes": "Sí",
	"dialog.no": "No",
	"generic.remove": "Eliminar",
	"generic.download": "Descargar",
	"generic.search": "Buscar",
	"dates.today": "Hoy",
	"dates.yesterday": "Ayer",
	"dates.this_week": "Esta semana",
	"dates.weeks_ago": "Hace %0 semanas",
	"mode.start.new": "Nuevo",
	"mode.start.recent": "Reciente",
	"format.free": "Modelo libre",
	"format.free.desc": "Modelo sin restricciones. Para renders, Unity, etc.",
	"format.java_block": "Item/Bloque de Java",
	"format.java_block.desc": "Modelo de bloque o item para la edición Java.",
	"format.bedrock": "Entidad de Bedrock",
	"format.bedrock.desc": "Modelo de Minecraft Bedrock Edition para entidades y objetos acoplables",
	"format.bedrock_old": "Modelo Antiguo de Bedrock",
	"format.bedrock_old.desc": "Modelo de entidad de las ediciones de Bedrock anteriores a 1.12",
	"format.modded_entity": "Entidad de Mod",
	"format.modded_entity.desc": "Modelo de entidad para mods. Pueden ser exportados como archivos de clase .java",
	"format.optifine_entity": "Entidad de OptiFine",
	"format.optifine_entity.desc": "Modelo de entidad específico para OptiFine",
	"keys.mouse": "Botón %0 del Ratón",
	"message.cleared_blank_faces.title": "Caras en Blanco",
	"message.cleared_blank_faces.message": "Blockbench ha encontrado %0 cubos sin textura. ¿Quieres eliminar esos elementos?",
	"message.wireframe.enabled": "Visualización de la estructura activada",
	"message.wireframe.disabled": "Visualización de la estructura desactivada",
	"dialog.convert_project.title": "Convertir Proyecto",
	"dialog.create_texture.double_use": "Mantener la Ocupación de Múltiples Texturas",
	"dialog.model_stats.title": "Estadísticas del Modelo",
	"dialog.model_stats.cubes": "Cubos",
	"dialog.model_stats.locators": "Localizadores",
	"dialog.model_stats.groups": "Grupos",
	"dialog.model_stats.vertices": "Vértices",
	"dialog.model_stats.faces": "Caras",
	"settings.username": "Usuario",
	"settings.username.desc": "Usuario para sesiones de edición",
	"settings.painting_grid": "Cuadrícula de Pintura",
	"settings.painting_grid.desc": "Muestra la cuadrícula en cubos texturizados en el modo pintura",
	"action.convert_project": "Convertir Proyecto",
	"action.convert_project.desc": "Convierte el proyecto actual a un proyecto para otro formato de modelo",
	"action.close_project": "Cerrar Proyecto",
	"action.close_project.desc": "Cierra el proyecto abierto actualmente",
	"action.export_bedrock": "Exportar como Geometría de Bedrock",
	"action.export_bedrock.desc": "Exporta el modelo como un archivo de geometría de la edición Bedrock",
	"action.save_project": "Guardar Proyecto",
	"action.save_project.desc": "Guarda el modelo actual como un archivo de proyecto",
	"action.save_project_as": "Guardar Proyecto Como",
	"action.save_project_as.desc": "Guarda el modelo actual como un archivo de proyecto en una nueva localización",
	"action.export_over": "Guardar Modelo",
	"action.export_over.desc": "Guarda el modelo, las texturas y las animaciones al sobreescribir los archivos",
	"action.add_locator": "Añadir Localizador",
	"action.add_locator.desc": "Añade un nuevo localizador para controlar las posiciones de partículas, cadenas, etc...",
	"action.uv_turn_mapping": "Girar Mapeado",
	"action.uv_turn_mapping.desc": "Gira el mapeado del UV 90º",
	"action.remove_blank_faces": "Eliminar Caras en Blanco",
	"action.remove_blank_faces.desc": "Elimina todas las caras sin textura de la selección",
	"web.download_app": "Descargar Aplicación",
	"uv_editor.turned": "Mapeado Girado",
	"display.reference.crossbow": "Ballesta Cargada",
	"dialog.settings.search_results": "Resultados de Búsqueda",
	"settings.animation_snap": "Imán de Animación",
	"settings.animation_snap.desc": "Intervalo del imán para fotogramas clave en la línea de tiempo de la animación en pasos por segundo. Esto puede ser modificado para cada animación. El valor por defecto es 24.",
	"action.import_optifine_part": "Importar Parte de OptiFine",
	"action.import_optifine_part.desc": "Importa un modelo de parte de entidad para OptiFine",
	"data.locator": "Localizador",
	"mode.start.no_recents": "No hay modelos abiertos recientemente",
	"panel.element": "Elemento",
	"panel.element.position": "Posición",
	"panel.element.size": "Tamaño",
	"panel.element.origin": "Punto de Pivote",
	"panel.element.rotation": "Rotación",
	"message.canvas_limit_error.title": "Error de Límite del Lienzo",
	"message.canvas_limit_error.message": "La acción no pudo ser ejecutada correctamente porque el formato limita el lienzo a 48 unidades. Cambia el punto pivote para prevenir esto.",
	"data.effect": "Efecto",
	"generic.name": "Nombre",
	"settings.recent_projects": "Límite de Modelos Recientes",
	"settings.recent_projects.desc": "Número máximo de modelos recientes para recordar",
	"settings.volume": "Volumen",
	"settings.volume.desc": "Control del volumen para efectos de sonido en animaciones",
	"action.clear_timeline": "Limpiar Línea de Tiempo",
	"action.clear_timeline.desc": "Borra todos los huesos no seleccionados en la línea de tiempo",
	"action.select_effect_animator": "Animar Efectos",
	"action.select_effect_animator.desc": "Abre la línea de tiempo para añadir sonidos y efectos de partícula",
	"action.timeline_focus": "Canal",
	"action.timeline_focus.desc": "Selecciona los canales de animación para mostrar en la línea de tiempo",
	"timeline.particle": "Partícula",
	"timeline.sound": "Sonido",
	"timeline.effects": "Efectos",
	"data.format": "Formato",
	"format.optifine_part": "Parte de OptiFine",
	"format.optifine_part.desc": "Parte JPM para modelos de entidad de OptiFine",
	"action.reverse_keyframes": "Invertir Fotogramas Clave",
	"action.reverse_keyframes.desc": "Invierte el orden de los fotogramas clave seleccionados",
	"generic.help": "Ayuda",
	"message.removed_faces": "Eliminadas %0 caras",
	"dialog.sketchfab_uploader.draft": "Borrador",
	"action.slider_pos": "Mover %0",
	"action.slider_pos.desc": "Mover elementos en el eje %0",
	"action.slider_size": "Tamaño %0",
	"action.slider_size.desc": "Redimensionar elementos en el eje %0",
	"action.slider_rotation": "Rotar %0",
	"action.slider_rotation.desc": "Rotar cubos en el eje %0",
	"action.slider_origin": "Pivote %0",
	"action.slider_origin.desc": "Mover pivote en el eje %0",
	"action.rotate_cw": "Rotar %0 +90",
	"action.rotate_cw.desc": "Rotar los cubos seleccionados 90º en el eje %0",
	"action.rotate_ccw": "Rotar %0 -90",
	"action.rotate_ccw.desc": "Rotar los cubos seleccionados -90º en el eje %0",
	"action.flip": "Voltear %0",
	"action.flip.desc": "Voltea los cubos seleccionados en el eje %0",
	"action.center": "Centrar %0",
	"action.center.desc": "Centra los cubos seleccionados en el eje %0",
	"action.bring_up_all_animations": "Subir Todas las Animaciones",
	"panel.bone": "Hueso",
	"data.color": "Color",
	"generic.export": "Exportar",
	"generic.none": "Ninguno",
	"status_bar.recording": "Grabando Timelapse",
	"message.add_to_palette": "Añadido a la paleta",
	"message.size_modifiers": "Mantén pulsado Ctrl o Shift para transformar en incrementos más pequeños",
	"message.timelapse_start": "Timelapse iniciado",
	"message.timelapse_stop": "Timelapse parado",
	"message.import_palette.replace_palette": "Reemplazar paleta vieja",
	"message.import_palette.threshold": "Unir Límite",
	"dialog.timelapse.interval": "Intervalo (Segundos)",
	"dialog.timelapse.source": "Fuente",
	"dialog.timelapse.source.interface": "Interfaz",
	"dialog.timelapse.source.locked": "Angulo Bloqueado",
	"dialog.timelapse.destination": "Carpeta de Destino",
	"layout.color.checkerboard": "Cuadrícula",
	"layout.color.checkerboard.desc": "Fondo del canvas y el editor de UV",
	"layout.font.code": "Fuente de Código",
	"layout.css": "CSS Personalizado",
	"settings.category.paint": "Pintar",
	"settings.deactivate_size_limit": "Desactivar Límite de Tamaño",
	"settings.deactivate_size_limit.desc": "Desactiva el límite de tamaño para algunos formatos de modelo. ADVERTENCIA: Esto puede crear modelos inválidos.",
	"settings.brush_opacity_modifier": "Modificador de Opacidad del Pincel",
	"settings.brush_opacity_modifier.desc": "Modifica la opacidad del pincel al usar un lápiz",
	"settings.brush_size_modifier": "Modificador de Tamaño del Pincel",
	"settings.brush_size_modifier.desc": "Modifica el tamaño del pincel al usar un lápiz",
	"settings.brush_modifier.pressure": "Presión",
	"settings.brush_modifier.tilt": "Inclinar",
	"category.color": "Color",
	"action.import_theme": "Importar Tema",
	"action.export_theme": "Exportar Tema",
	"action.export_theme.desc": "Crea un archivo de tema basado en la configuración actual",
	"action.slider_color_h": "Tono",
	"action.slider_color_s": "Saturación",
	"action.slider_color_v": "Valor",
	"action.add_to_palette": "Añadir a la Paleta",
	"action.add_to_palette.desc": "Añade el color seleccionado a la paleta de colores",
	"action.import_palette": "Importar Paleta",
	"action.import_palette.desc": "Importar un .bbpalette",
	"action.export_palette": "Exportar Paleta",
	"action.export_palette.desc": "Exporta la paleta como un archivo .GPL",
	"action.generate_palette": "Generar Paleta",
	"action.generate_palette.desc": "Genera la paleta a partir de una textura",
	"action.sort_palette": "Organizar Paleta",
	"action.sort_palette.desc": "Organiza todos los colores de la paleta por color y brillo",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Graba un timelapse de tu proceso de modelaje",
	"action.add_keyframe": "Añadir Frame Clave",
	"action.add_keyframe.desc": "Añade un frame clave automáticamente. Pulsa shift para forzar los valores por defecto",
	"action.bring_up_all_animations.desc": "Trae todos los animadores modificados a la línea de tiempo",
	"timeline.timeline": "Instrucciones",
	"menu.palette.load.default": "Por Defecto",
	"panel.color.picker": "Seleccionador",
	"panel.color.palette": "Paleta",
	"generic.import": "Importar",
	"settings.brush_modifier.none": "Ninguno",
	"action.export_entity": "Exportar Entidad de Bedrock",
	"action.export_entity.desc": "Añadir el modelo actual como una entidad a un archivo mobs.json",
	"settings.highlight_cubes": "Resaltar Cubos",
	"settings.highlight_cubes.desc": "Resaltar los cubos cuando pasas por encima de ellos o los seleccionas",
	"action.add_marker": "Poner Marcador",
	"action.add_marker.desc": "Pone un marcador de línea de tiempo",
	"timeline.pre_effect_script": "Guión",
	"format.skin": "Skin",
	"format.skin.desc": "Editar las skins de entidades y jugadores",
	"message.sketchfab.setup_guide": "¿Quieres aprender a preparar modelos en Sketchfab? Lee %0",
	"dialog.skin.title": "Crear Skin",
	"dialog.skin.model": "Modelo",
	"dialog.skin.texture": "Textura (Opcional)",
	"action.toggle_skin_layer": "Cambiar Capa de Skin",
	"action.toggle_skin_layer.desc": "Cambia la capa del gorro y de la ropa en el modelo de skin",
	"action.gui_light": "Luz en GUI",
	"action.gui_light.desc": "Selecciona la forma en la que el ítem es iluminado en el inventario",
	"action.gui_light.side": "Luz Lateral",
	"action.gui_light.front": "Luz Frontal",
	"action.move_keyframe_back": "Mover Fotogramas Clave Atrás",
	"action.move_keyframe_forth": "Mover Fotogramas Clave Adelante",
	"menu.help": "Ayuda",
	"menu.help.discord": "Servidor de Discord",
	"menu.help.report_issue": "Reportar un Problema",
	"menu.help.plugin_documentation": "Documentación de la API de Plugins",
	"menu.help.search_action": "Buscar y Ejecutar Acción",
	"menu.help.donate": "Donar",
	"menu.help.about": "Acerca de...",
	"menu.preview.background.clipboard": "Cargar desde Portapapeles",
	"dialog.ignore": "Ignorar",
	"generic.unset": "Desajustar",
	"message.invalid_builtin_parent.title": "Padre Incorporado Inválido",
	"message.invalid_builtin_parent.message": "El enlace al modelo inválido padre '%0' fue quitado para exportar un modelo válido.",
	"dialog.resize_texture.fill": "Rellenar con",
	"dialog.resize_texture.fill.transparent": "Transparente",
	"dialog.resize_texture.fill.color": "Color",
	"dialog.resize_texture.fill.repeat": "Repetir",
	"dialog.scale.element_pivot": "Pivote de Elemento",
	"dialog.scale.selection_center": "Centro de Selección",
	"dialog.create_gif.length_mode": "Modo de Longitud",
	"dialog.create_gif.length_mode.seconds": "Segundos",
	"dialog.create_gif.length_mode.frames": "Fotograma",
	"dialog.create_gif.length_mode.animation": "Longitud de Animación",
	"dialog.create_gif.length_mode.turntable": "Rotación de Bombero",
	"dialog.save_angle.projection": "Proyección",
	"dialog.save_angle.projection.perspective": "Perspectiva",
	"dialog.save_angle.projection.orthographic": "Ortogonal",
	"dialog.sketchfab_uploader.animations": "Animaciones",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Interfaz",
	"settings.preview_checkerboard": "Previsualizar Cuadrícula",
	"settings.preview_checkerboard.desc": "Cambia el fondo de la cuadrícula detrás de la previsualización",
	"settings.uv_checkerboard": "Cuadrícula del Editor de UV",
	"settings.uv_checkerboard.desc": "Cambia el fondo de la cuadrícula detrás del editor de UV",
	"category.paint": "Pintar",
	"action.fill_mode.color_connected": "Colores Conectados",
	"action.draw_shape_type": "Tipo de Forma",
	"action.draw_shape_type.rectangle": "Rectángulo",
	"action.draw_shape_type.rectangle_h": "Rectángulo (Hueco)",
	"action.draw_shape_type.ellipse": "Elipse",
	"action.draw_shape_type.ellipse_h": "Elipse (Hueca)",
	"action.draw_shape_type.line": "Línea",
	"action.mirror_painting": "Invertir Pintura",
	"action.mirror_painting.description": "Invierte tus trazos de pintura al otro lado del moedlo",
	"action.lock_alpha": "Bloquear Canal Alfa",
	"action.lock_alpha.description": "Bloquea la transparencia de todos los píxeles",
	"action.draw_shape_tool": "Dibujar Figura",
	"action.draw_shape_tool.desc": "Herramienta para dibujar figuras simples en texturas",
	"action.export_gltf": "Exportar como gITF",
	"action.export_gltf.desc": "Exporta el modelo y las animaciones como un archivo gITF para usarlo en otras aplicaciones 3D",
	"action.transform_space": "Transformar Espacio",
	"action.transform_space.desc": "Espacio de transformación por defecto para elementos y huesos",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Local",
	"action.toggle_camera_projection": "Cambiar Cámara de Proyección",
	"action.toggle_camera_projection.desc": "Cambia la cámara de proyección entre perspectiva y ortogonal",
	"action.load_camera_angle": "Ángulo de Cámara: %0",
	"action.load_camera_angle.desc": "Cargar el ángulo de cámara: '%0'",
	"action.slider_face_tint": "Índice de Tintado",
	"action.slider_face_tint.desc": "Ajusta el índice de tintado de la cara actual. -1 significa sin ajustar.",
	"menu.help.quickstart": "Asistente de Inicio Rápido",
	"menu.help.developer": "Desarrollador",
	"menu.help.developer.dev_tools": "Abre las Herramientas de Desarrollador",
	"menu.help.developer.reset_storage": "Reinicio de Fábrica",
	"menu.help.developer.reset_storage.confirm": "¿Seguro que quieres reiniciar Blockbench a los ajustes de fábrica? Esto borrará todos los ajustes personalizados, las teclas asignadas y los plugins instalados.",
	"menu.help.developer.cache_reload": "Recargar Caché",
	"menu.preview.orthographic": "Ortogonal",
	"menu.preview.save_angle": "Guardar Ángulo...",
	"menu.preview.angle": "Ángulos",
	"menu.preview.angle.initial": "Ángulo inicial",
	"menu.preview.maximize": "Maximizar",
	"panel.color.both": "Ambos",
	"uv_editor.copy_selection": "Copiar selección",
	"uv_editor.paste_selection": "Pegar selección",
	"uv_editor.copy_paste_tool.place": "Lugar",
	"uv_editor.copy_paste_tool.mirror_x": "Invertir X",
	"uv_editor.copy_paste_tool.mirror_y": "Invertir Y",
	"uv_editor.copy_paste_tool.rotate": "Rotar 90 Grados",
	"dialog.project.modded_entity_version": "Exportar Versión",
	"dialog.save_angle.position": "Posición de la Cámara",
	"dialog.save_angle.target": "Punto Focal",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Marco de Ventana",
	"layout.color.frame.desc": "Borde y barra de título de la ventana",
	"settings.large_grid_size": "Tamaño del Bloque de Cuadrícula",
	"settings.large_grid_size.desc": "Tamaño del bloque de la cuadrícula",
	"action.load_plugin_from_url": "Cargar Plugin desde URL",
	"action.load_plugin_from_url.desc": "Carga un plugin desde un servidor a través de una URL",
	"action.cube_counter.desc": "Muestra el número actual de cubos y otras estadísticas",
	"action.unlock_everything": "Desbloquear Todo",
	"action.unlock_everything.desc": "Desbloquea todos los grupos y elementos en el Esquema",
	"action.load_palette": "Cargar Paleta",
	"action.load_palette.desc": "Carga una de las plantillas de paletas predeterminadas",
	"action.toggle_locked": "Cambiar Bloqueo",
	"action.toggle_locked.desc": "Cambiar si los elementos actuales están bloqueados o no",
	"action.apply_display_preset": "Aplicar Plantilla",
	"action.apply_display_preset.desc": "Aplica una plantilla de ajustes de visualización por defecto o personalizada",
	"action.apply_display_preset.here": "Aplicar A Este Apartado",
	"action.apply_display_preset.everywhere": "Aplicar A Todos los Apartados",
	"action.resolve_keyframe_expressions": "Resolver Fotogramas Clave",
	"action.resolve_keyframe_expressions.desc": "Resuelve las expresiones matemáticas de los fotogramas clave seleccionados",
	"action.fold_all_animations": "Plegar Todos los Animadores",
	"menu.palette.load.empty": "Vacío",
	"switches.lock": "Bloquear",
	"settings.render_sides": "Renderizar Lados",
	"settings.render_sides.desc": "Seleccionar qué lado de una cara es renderizado",
	"settings.render_sides.auto": "Automático",
	"settings.render_sides.front": "Exterior",
	"settings.render_sides.double": "Interior y Exterior",
	"generic.enable": "Activar",
	"generic.disable": "Desactivar",
	"generic.redacted": "Censurado",
	"dialog.select_texture.import_all": "Importar Todas",
	"dialog.skin.layer_template": "Textura de Capa",
	"about.version.up_to_date": "Actualizado",
	"about.version.update_available": "La versión %0 está disponible",
	"settings.category.application": "Aplicación",
	"settings.streamer_mode": "Modo Streamer",
	"settings.streamer_mode.desc": "Esconde información sensible como los modelos recientes",
	"settings.automatic_updates": "Actualizaciones Automáticas",
	"settings.automatic_updates.desc": "Actualiza automáticamente nuevas versiones y mantiene Blockbench actualizado",
	"action.rotation_space": "Espacio de Rotación",
	"action.focus_on_selection": "Centrar Vista en Selección",
	"action.focus_on_selection.desc": "Ajusta la cámara para mirar hacia el centro de la selección actual",
	"action.jump_to_timeline_start": "Saltar a Inicio de Animación",
	"action.jump_to_timeline_end": "Saltar a Fin de Animación",
	"menu.help.updating": "Actualizando (%0%)",
	"menu.help.update_failed": "Actualización Fallida",
	"menu.animation.loop.once": "Reproducir Una Vez",
	"menu.animation.loop.hold": "Pausar en Último Fotograma",
	"menu.animation.loop.loop": "Repetir",
	"interface.streamer_mode_on": "Modo Streamer Activado",
	"generic.reset": "Reiniciar",
	"generic.restore": "Restaurar",
	"keys.mousewheel": "Rueda de ratón",
	"message.delete_animation.title": "Eliminar animación",
	"message.delete_animation.message": "La animación se eliminó de Blockbench. ¿También desea eliminar la animación del archivo en el que se guardó?",
	"message.no_animation_to_import": "No hay animaciones para importar",
	"dialog.material_instances.title": "Instancias de material",
	"dialog.animation_import.title": "Seleccionar animaciones para importar",
	"dialog.create_texture.padding": "Relleno",
	"settings.fov": "FOV",
	"settings.fov.desc": "Campo de visión de la cámara. El valor predeterminado es 45",
	"settings.sync_color": "Sincronizar color",
	"settings.sync_color.desc": "Sincronizar el color entre diferentes instancias de Blockbench",
	"settings.minify_bbmodel": "Archivos del Projecto reducidos",
	"settings.minify_bbmodel.desc": "Escribi los archivos .bbmodel reducidos en una linea",
	"action.edit_material_instances": "Editar Instancias de material",
	"action.edit_material_instances.desc": "Editar las instancias de los nombres de los materiales para las geometrias de bloques para bedrock",
	"action.save_all_animations": "Guardar todas las animaciones",
	"action.save_all_animations.desc": "Guardar todas las animaciones abiertas en el momento",
	"action.keyframe_interpolation": "Interpolación",
	"action.keyframe_interpolation.desc": "Seleciona el modo de interpolacion de fotogramas",
	"action.keyframe_interpolation.linear": "Lineal",
	"action.keyframe_interpolation.catmullrom": "Liso",
	"action.timeline_focus.hide_empty": "Esconder canales vacíos",
	"menu.file.preferences": "Preferencias",
	"menu.animation.blend_weight": "Peso en union",
	"menu.animation.save": "Guardar",
	"menu.animation.properties": "Propiedades...",
	"menu.animation.file": "Archivo",
	"menu.animation.snapping": "Usar Imán",
	"menu.animation.open_location": "Abrir directorio del archivo",
	"panel.keyframe.add_data_point": "Agregar punto de datos del Frame Clave",
	"panel.keyframe.remove_data_point": "Remover punto de datos",
	"panel.keyframe.pre": "Pre",
	"panel.keyframe.post": "Post",
	"generic.all": "Todo",
	"message.small_face_dimensions.title": "Dimensiones de Cara Incompatibles",
	"message.small_face_dimensions.message": "La selección contiene caras que son más pequeñas que 1 unidad en una dirección. El sistema del mapeo Box UV considera cualquier cara por debajo de ese umbral como 0 píxeles de ancho. Por lo tanto, es posible que la textura de esas caras no funcione correctamente.",
	"message.small_face_dimensions.face_uv": "El formato actual admite mapas UV por cara que pueden manejar dimensiones de caras pequeñas. Vaya a \"Archivo\"> ​​\"Proyecto ...\" y cambie \"Modo UV\" a \"UV por cara\".",
	"dialog.plugins.outdated_client": "Requiere una versión más reciente de Blockbench",
	"dialog.plugins.outdated_plugin": "El complemento está desactualizado y no funciona con esta versión de Blockbench",
	"settings.motion_trails": "Senderos de movimiento",
	"settings.motion_trails.desc": "Mostrar senderos de movimiento en el editor de animación",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Alternar el anti-aliasing en la vista previa",
	"action.timeline_frame_back": "Avanza un fotograma atras",
	"action.timeline_frame_forth": "Avanza un fotograma adelante",
	"panel.bone.ik": "Cinemáticas inversas (Experimental)",
	"settings.particle_tick_rate": "Partícula de la tasa de tic",
	"settings.particle_tick_rate.desc": "Efectos de partículas en la tasa de tic por segundo. El defecto es 30",
	"action.lock_motion_trail": "Bloquear el rastro de movimiento",
	"action.lock_motion_trail.desc": "Bloquear el rastro de movimiento en el grupo seleccionado",
	"menu.animation_file.unload": "Descargar archivo",
	"data.null_object": "Objeto Nulo",
	"status_bar.toggle_sidebar": "Mostrarbarralateral",
	"message.load_plugin_failed.title": "Falló al cargar el plugin",
	"message.load_plugin_failed.message": "Asegúrate que el nombre del archivo del plugin corresponde al ID `%0`, tal como se especifica en Plugin.Register().",
	"dialog.project.uv_mode": "Modo UV",
	"dialog.project.uv_mode.box_uv": "Caja UV ",
	"dialog.project.uv_mode.face_uv": "UV por cara",
	"dialog.project.texture_size": "Tamaño de la textura",
	"dialog.animation_export.title": "Selecciona animaciones a exportar",
	"dialog.create_texture.rearrange_uv": "UV de arranque",
	"layout.color.subtle_text": "Texto subtítulo",
	"layout.color.subtle_text.desc": "Color del texto secundario con menos contraste",
	"settings.interface_scale": "Escala de la interfaz",
	"settings.interface_scale.desc": "Escala de la interfaz de Blockbench",
	"settings.background_rendering": "Renderizado del fondo",
	"settings.background_rendering.desc": "Actualiza la previsualización mientras la ventana no esté enfocada",
	"settings.ctrl_shift_size": "Resolución de Control + Shift",
	"settings.ctrl_shift_size.desc": "Resolución del mapa mientras mantienes presionado control y shift",
	"settings.hardware_acceleration": "Aceleración de Hardware",
	"settings.hardware_acceleration.desc": "Subcontratar tareas de renderizado a la tarjeta gráfica",
	"action.explode_skin_model": "Expandir Modelo de Skin",
	"action.explode_skin_model.desc": "Alternar a una vista de explosión que le permite editar caras cubiertas",
	"action.export_minecraft_skin": "Exportar Skin de Minecraft",
	"action.export_minecraft_skin.desc": "Exportar la Skin de Minecraft como una textura PNG",
	"action.add_null_object": "Agregar un objeto nulo",
	"action.add_null_object.desc": "Agrega un nuevo objeto nulo",
	"action.animated_texture_frame": "Fotograma de Texturas Animadas",
	"action.animated_texture_frame.desc": "Posicionar el fotograma actual en la textura animada",
	"action.export_animation_file": "Exportar animaciones...",
	"action.export_animation_file.desc": "Exportar una selección de animaciones a un nuevo archivo",
	"action.timeline_graph_editor": "Editor gráfico",
	"action.timeline_graph_editor.desc": "Alternar a la línea de tiempo entre la vista del editor de gráficos y la vista de fotogramas clave",
	"menu.file.recent.clear": "Limpiar archivos recientes",
	"switches.shade": "Sombra",
	"generic.share": "Compartir",
	"dates.minute": "%0 Minuto",
	"dates.minutes": "%0 Minutos",
	"dates.hour": "%0 Hora",
	"dates.hours": "%0 Horas",
	"dates.day": "%0 Día",
	"dates.days": "%0 Días",
	"dates.week": "%0 Semana",
	"dates.weeks": "%0 Semanas",
	"dates.year": "%0 Año",
	"dates.years": "%0 Años",
	"message.installed_plugin": "Exitosamente instalado el plugin %0",
	"message.installed_plugin_fail": "Falló la instalación del plugin %0",
	"dialog.share_model.title": "Compartir Modelo",
	"dialog.share_model.expire_time": "Tiempo de Expiración",
	"dialog.share_model.failed": "Falló la subida del modelo",
	"action.import_java_block_model": "Añade un Modelo de Bloque/Item de Java",
	"action.import_java_block_model.desc": "Añade un Modelo de Bloque/Item de Minecraft Java desde un archivo json al modelo actual",
	"action.share_model": "Compartir...",
	"action.share_model.desc": "Genera un enlace corto para compartir tu modelo",
	"action.import_project": "Importar Proyecto",
	"action.import_project.desc": "Importar otro proyecto desde un archivo .bbmodel al proyecto actual",
	"dialog.toolbar_edit.hidden_tools": "Algunas herramientas podrían estar ocultas porque no están disponibles en el modo, formato o situación actual.",
	"settings.camera_near_plane": "Cámara cerca del plano",
	"settings.camera_near_plane.desc": "La mínima distancia de la cámara en el renderizado de los objetos. El valor máximo imprementa el Z-fighting. El defecto es 1",
	"mode.start.keymap_preference.desc": "Si eres nuevo en Blockbench y vienes de otro programa en 3D, puedes seleccionar un mapa de teclas para hacer mas fácil tu transición. Puedes cambiar este mapa de teclas o los atajos de tecla individuales después en las configuraciones.",
	"message.load_keymap": "¿Estás seguro que quieres cargar este mapa de teclas? Esto sobreescribirá tus actuales atajos de teclado.",
	"message.keymap_loaded": "Mapa de Teclas cargado",
	"dialog.convert_project.current_format": "Formato Actual",
	"dialog.create_texture.rearrange_uv.desc": "Crear una nueva UV de arreglo para otorgar a cada cara un lugar único en la textura",
	"dialog.create_texture.power.desc": "Bloquea la textura automática al tamaño de poder-de-2, de 64 o 128. Esto requiere varios renderizados",
	"dialog.create_texture.double_use.desc": "Si dos elementos tienen el mismo espacio del UV asignado, mantenlo así para un nuevo mapa",
	"dialog.create_texture.padding.desc": "Añadir un pequeño relleno entre partes individuales de la plantilla",
	"dialog.create_texture.resolution.desc": "El tamaño y la altura de la textura",
	"dialog.create_gif.color": "Color del fondo",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Los huesos opuestos están identificados a \"Izquierda\" y \"Derecha\" sin su nombre.",
	"dialog.flip_animation.offset": "Compensado por la mitad de la duración de la animación",
	"dialog.export_private_settings.title": "Configuración privada",
	"dialog.export_private_settings.message": "Tu archivo contiene la siguiente información privada: **%0**. Deje estos valores fuera si planea compartir este archivo con alguien más.",
	"dialog.export_private_settings.keep": "Mantener",
	"settings.timecode_frame_number": "Mostrar los códigos de tiempo como un marco numérico",
	"settings.timecode_frame_number.desc": "Mostrar códigos de tiempo de fracción en la línea de tiempo como número de cuadro en lugar de centisegundos",
	"settings.animation_sample_rate": "Tarifa simple animada",
	"settings.animation_sample_rate.desc": "Frecuencia de muestro en muestras por segundo para curvas que el formato respectivo no admite de forma nativa",
	"keybind.preview_zoom": "Vista de zoom",
	"action.gradient_tool": "Herramienta de Gradiente",
	"action.gradient_tool.desc": "Crea un gradiente de un color en tu textura",
	"action.import_settings": "Importar Configuraciones",
	"action.import_settings.desc": "Importar un archivo .bbsettings",
	"action.export_settings": "Exportar Configuraciones",
	"action.export_settings.desc": "Exportar las configuraciones de Blockbench como archivos .bbsettings",
	"action.load_keymap": "Cargar Mapa de Teclas",
	"action.load_keymap.default": "Por Defecto (Panel Táctil/Mouse)",
	"action.load_keymap.mouse": "Por Defecto (Mouse)",
	"action.load_keymap.default.desc": "Combinaciones de teclas predeterminadas de Blockbench, con controles de navegación optimizado para portátiles con panel táctil",
	"action.load_keymap.mouse.desc": "Combinaciones de teclas predeterminadas de Blockbench, con navegación de ventana gráfica vinculada al botón central del ratón",
	"action.load_keymap.blender.desc": "Mapa de Teclas para usuarios que están familiarizados con los controles de Blender",
	"action.load_keymap.cinema4d.desc": "Mapa de Teclas para usuarios que están familiarizados con los controles de Cinema 4D",
	"action.load_keymap.maya.desc": "Mapa de Teclas para usuarios que estan familiarizados con los controles de Autodek Maya",
	"action.import_keymap": "Importar Mapa de Teclas",
	"action.import_keymap.desc": "Importar atajos de teclado a un archivo .bbkeymap",
	"action.export_keymap": "Exportar Mapa de Teclas",
	"action.export_keymap.desc": "Exportar los actuales atajos de teclado como un archivo .bbkeymap",
	"action.edit_history": "Editar Historial...",
	"action.edit_history.desc": "Ver el historial de edición y deshacer o rehacer pasos",
	"action.group_elements": "Elementos del Grupo",
	"action.group_elements.desc": "Envolver los elementos seleccionados a un nuevo grupo",
	"action.unfold_groups": "Desplegar Grupos",
	"action.unfold_groups.desc": "Desplegar todos los grupos del perfilador",
	"action.edit_bedrock_binding": "Editar unión",
	"action.edit_bedrock_binding.desc": "Cambiar el hueso de geometría",
	"action.pick_screen_color": "Seleccionar color en pantalla",
	"action.pick_screen_color.desc": "Seleccionar un color de la pantalla",
	"action.view_mode": "Modo de Vista",
	"action.view_mode.desc": "Cambiar el modo de vista del modelo",
	"action.view_mode.textured": "Texturado",
	"action.view_mode.solid": "Solido",
	"action.view_mode.wireframe": "Marco de alambres",
	"action.toggle_sidebars": "Alternar las barras laterales",
	"action.toggle_sidebars.desc": "Habilitar o inhabilitar las barras laterales",
	"action.set_animation_end": "Establecer el final en la animación",
	"action.set_animation_end.desc": "Establecer el final de la animación seleccionada en el periodo de tiempo seleccionado",
	"action.flip_animation": "Voltear animación",
	"action.flip_animation.desc": "Voltea parte de una animación copiando fotogramas clave seleccionados al otro lado del modelo",
	"action.graph_editor_zero_line": "Incluir línea cero",
	"action.graph_editor_zero_line.desc": "Si el editor de gráficos siempre incluye la línea cero en la vista",
	"menu.texture.render_mode": "Modo de Renderización",
	"menu.texture.render_mode.emissive": "Emisivo",
	"menu.texture.render_mode.layered": "En capas",
	"menu.preview.angle.edit": "Editar Ángulo...",
	"menu.animation.start_delay": "Empezar Desfase",
	"menu.animation.loop_delay": "Repetir Desfase",
	"menu.animation.flip_keyframes": "Voltear Fotogramas",
	"menu.mobile_keyboard.disable_all": "Desactivar Todo",
	"panel.keyframe.toggle_uniform_scale": "Cambiar Reescalado Uniforme",
	"camera_angle.common_isometric_right": "Isométrico derecho (2:1)",
	"camera_angle.common_isometric_left": "Isométrico izquierdo (2:1)",
	"camera_angle.true_isometric_right": "Isométrico correcto derecho (30 grados)",
	"camera_angle.true_isometric_left": "Isométrico correcto izquierdo (30 grados)",
	"menu.help.wiki": "Wiki de BlockBench",
	"settings.update_to_prereleases": "Actualizar a una versión Preliminar",
	"settings.update_to_prereleases.desc": "Actualiza automáticamente a una versión beta de Blockbench para probar nuevas características. Las versiones Preliminares pueden ser inestables, no actives esta opción si confía en Blockbench para el trabajo u otros proyectos importantes.",
	"data.separator.spacer": "Espaciador",
	"data.separator.linebreak": "Salto de línea",
	"data.setting": "Configuraciones",
	"generic.select_all": "Seleccionar Todo",
	"generic.select_none": "Seleccionar Nada",
	"projects.new_tab": "Nueva Pestaña",
	"projects.close_tab": "Cerrar Pestaña",
	"message.invalid_format.title": "Formato Inválido",
	"message.invalid_format.message": "Este modelo fue hecho en el formato '%0', el cual no está disponible en tu instalación de Blockbench. Lo mas probable es que necesite un complemento en específico para abrirlo correctamente",
	"message.invalid_link": "Link del Modelo Inválido o Expirado",
	"message.default_textures.current": "Ruta actual",
	"message.update_after_restart": "La actualización será instalada después del próximo reinicio",
	"message.copy_paste_tool_viewport": "Esta herramienta sólo puede utilizarse en el editor 2D",
	"dialog.project.shadow_size": "Tamaño de la Sombra",
	"dialog.find_replace.target": "Objetivo",
	"dialog.find_replace.target.element_names": "Nombres de los Elementos",
	"dialog.find_replace.target.group_names": "Nombres de los Grupos",
	"dialog.find_replace.target.animation_names": "Nombres de las Animaciones",
	"dialog.find_replace.target.keyframe_values": "Valor de los Fotogramas",
	"dialog.find_replace.find": "Buscar",
	"dialog.find_replace.replace": "Reemplazar",
	"dialog.find_replace.regex": "Expresión regular",
	"dialog.add_primitive.shape": "Forma",
	"dialog.add_primitive.shape.circle": "Circulo",
	"dialog.add_primitive.shape.tube": "Tubo",
	"dialog.add_primitive.shape.cone": "Cono",
	"dialog.add_primitive.shape.cylinder": "Cilindro",
	"dialog.add_primitive.shape.sphere": "Esfera",
	"dialog.add_primitive.shape.torus": "Toro",
	"dialog.add_primitive.shape.cube": "Cuboide",
	"dialog.add_primitive.shape.pyramid": "Pirámide",
	"dialog.add_primitive.diameter": "Diámetro",
	"dialog.add_primitive.height": "Peso",
	"dialog.add_primitive.sides": "Lados",
	"dialog.add_primitive.minor_diameter": "Espesor",
	"dialog.add_primitive.minor_sides": "Lador Menores",
	"dialog.create_texture.combine_polys": "Combinar islas",
	"dialog.create_texture.combine_polys.desc": "Combinar caras en islas UV conectadas",
	"dialog.model_stats.meshes": "Mallas",
	"dialog.export_private_settings.omit": "Salir",
	"layout.select": "Seleccionar",
	"layout.options": "Opciones",
	"layout.color": "Escama de color",
	"layout.documentation": "Documentación",
	"layout.color.bright_ui_text": "Texto de interfaz brillante",
	"layout.color.bright_ui_text.desc": "Texto en fondos claros",
	"layout.name": "Nombre",
	"layout.author": "Autor",
	"settings.color_wheel": "Rueda de color",
	"settings.color_wheel.desc": "Usa la rueda de color como color principal",
	"settings.dialog.desc": "Muestra el dialogo \"%0\"",
	"settings.export_empty_groups": "Exportar los Grupos Vacíos",
	"settings.export_empty_groups.desc": "Incluir grupos sin contenido en archivos exportados",
	"category.separators": "Separadores",
	"keybind.preview_area_select": "Área de Selección",
	"action.color_erase_mode": "Modo Borrar",
	"action.color_erase_mode.desc": "Con el modo borrar activado, las herramientas como Llenar y Rectángulo quitan colores en vez de agregarlos",
	"action.open_from_link": "Abrir modelo desde el Link...",
	"action.open_from_link.desc": "Abrir un modelo desde un blckbn.ch URL",
	"action.import_obj": "Importar Modelo OBJ",
	"action.import_obj.desc": "Importar objetos de un modelo OBJ como una malla",
	"action.add_plugin": "Instalar Plugin",
	"action.add_plugin.desc": "Instala un plugin mediante un Control de Acción",
	"action.remove_plugin": "Desinstalar Plugin",
	"action.remove_plugin.desc": "Desinstala un plugin mediante un Control de Acción",
	"action.add_mesh": "Añadir malla",
	"action.add_mesh.desc": "Añadir una nueva malla",
	"action.add_texture_mesh": "Añadir una malla de textura",
	"action.add_texture_mesh.desc": "Añadir una nueva malla de textura",
	"action.find_replace": "Encontrar/Reemplazar...",
	"action.find_replace.desc": "Encontrar y reemplazar partes de los nombres",
	"action.hide_everything_except_selection": "Ocultar todo excepto la selección",
	"action.hide_everything_except_selection.desc": "Alternar la visualización en todos los elementos excepto los seleccionados",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Modo de Selección",
	"action.selection_mode.desc": "Cambiar cómo los elementos pueden ser seleccionados en el punto de mira",
	"action.selection_mode.object": "Objeto",
	"action.selection_mode.face": "Cara",
	"action.selection_mode.vertex": "Vértice",
	"action.create_face": "Crear punto de mira",
	"action.create_face.desc": "Crea una nueva cara o borde entre los vértices seleccionados",
	"action.convert_to_mesh": "Convertir a malla",
	"action.convert_to_mesh.desc": "Convertir los elementos seleccionados a mallas",
	"action.invert_face": "Invertir cara",
	"action.invert_face.desc": "Invertir las caras seleccionadas para hacerlas mirar en la direccion opuesta",
	"action.extrude_mesh_selection": "Extruir selección",
	"action.extrude_mesh_selection.desc": "Extruir las partes seleccionadas de la malla",
	"action.loop_cut": "Cortar repetición",
	"action.loop_cut.desc": "Divida la malla en un bucle a través del borde seleccionado",
	"action.merge_meshes": "Unir mallas",
	"action.merge_meshes.desc": "Combinar varias mallas en una",
	"action.keyframe_uniform": "Escalar uniforme",
	"action.keyframe_uniform.desc": "Habilite el escalado uniforme en los fotogramas clave seleccionados",
	"menu.locator.ignore_inherited_scale": "Ignorar escalado heredado",
	"menu.texture_mesh.texture_name": "Nombre de la Textura...",
	"menu.texture.elements": "Aplicar a Elementos",
	"uv_editor.transparent_face": "Transparentar Cara",
	"display.pose_angle": "Ángulo de Pose (Solo para Previsualización)",
	"data.mesh": "Malla",
	"dialog.create_texture.type": "Tipo",
	"dialog.create_texture.type.blank": "En Blanco",
	"dialog.create_texture.type.template": "Plantilla de textura",
	"dialog.create_texture.type.color_map": "Plantilla de Color Sólido",
	"dialog.sketchfab_uploader.suggested_tags": "Etiquetas sugeridas",
	"dialog.sketchfab_uploader.category": "Categoría",
	"dialog.sketchfab_uploader.category2": "Categoría 2",
	"layout.restore_backup": "Tu tema personalizado %0 fue sobreescrito. Clickea aquí para restaurarlo",
	"layout.borders": "Bordes",
	"action.fill_mode.element": "Elemento",
	"action.inset_mesh_selection": "Insertar selección",
	"action.inset_mesh_selection.desc": "Insertar la parte seleccionada de la malla",
	"action.dissolve_edges": "Disolver ejes",
	"action.dissolve_edges.desc": "Disolver los ejes seleccionados y unir las caras al dividir",
	"action.split_mesh": "Separar mallas",
	"action.split_mesh.desc": "Separar las mallas seleccionadas en una nueva malla",
	"action.merge_vertices": "Combinar vértices",
	"action.merge_vertices.desc": "Fusionar los vértices seleccionados en la posición del primer vértice seleccionado",
	"action.view_mode.normal": "Orientación de la cara",
	"action.snap_uv_to_pixels": "Cambiar UV a píxeles",
	"action.snap_uv_to_pixels.desc": "Ajusta los vértices UV seleccionados a la cuadrícula de píxeles",
	"menu.file.import.import_open_project": "Importar proyecto abierto",
	"menu.help.unlock_projects": "Desbloquea todos los proyectos",
	"status_bar.selection.faces": "%0 Caras",
	"status_bar.selection.vertices": "%0 Vertices",
	"message.merged_vertices": "Se encontraron y combinaron %0 vértices en %1 ubicaciones",
	"settings.vertex_merge_distance": "Distancia de fusión de vértices",
	"settings.vertex_merge_distance.desc": "Distancia dentro de la cual se fusionan los vértices mediante la fusión por distancia",
	"settings.show_only_selected_uv": "Mostrar solo UV seleccionado",
	"settings.show_only_selected_uv.desc": "Mostrar solo las caras UV seleccionadas en el editor UV de forma predeterminada",
	"action.merge_vertices.merge_all": "Unir todo",
	"action.merge_vertices.merge_all_in_center": "Unir todo al centro",
	"action.merge_vertices.merge_by_distance": "Unir distancia",
	"action.merge_vertices.merge_by_distance_in_center": "Unir distancia al centro",
	"action.uv_rotate_left": "Rotar UV a la izquierda",
	"action.uv_rotate_left.desc": "Rotar las caras UV seleccionadas en sentido anti-horario (izquierda)",
	"action.uv_rotate_right": "Rotar las caras UV a la derecha",
	"action.uv_rotate_right.desc": "Rotar las caras UV seleccionadas en sentido horario (derecha)",
	"menu.uv.display_uv": "Mostrar UV",
	"menu.uv.display_uv.selected_faces": "Caras seleccionadas",
	"menu.uv.display_uv.selected_elements": "Todas las caras",
	"menu.uv.display_uv.all_elements": "Todas las caras en todos los elementos",
	"menu.paste.face": "Cara UV",
	"menu.paste.mesh_selection": "Selección de malla",
	"menu.paste.outliner": "Elementos",
	"uv_editor.show_all_faces": "Mostrar todas las caras",
	"uv_editor.show_selected_faces": "Mostrar las caras seleccionadas",
	"status_bar.selection.edges": "0% de ejes",
	"action.selection_mode.edge": "Eje",
	"message.cannot_re_import.title": "Modelo no puede ser re-importado",
	"message.cannot_re_import.message": "El modelo del formato exportado no puede ser importado a BlockBench nuevamente. Por favor asegurate de guardar tu modelo como un archivo de proyecto.",
	"generic.default": "Por defecto",
	"units.pixels_per_meter": "%0 píxeles por metro",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "Reescalar en ambas direcciones",
	"modifier_actions.resize_one_side": "Reescalar en una sola dirección",
	"modifier_actions.draw_line": "Dibujar línea",
	"modifier_actions.drag_without_snapping": "Arrastar sin romper",
	"modifier_actions.stretch_keyframes": "Estirar fotogramas clave",
	"modifier_actions.resize_background": "Reescalar fondo",
	"modifier_actions.select_multiple": "Selección múltiple",
	"modifier_actions.select_range": "Seleccionar rango",
	"modifier_actions.drag_to_duplicate": "Arrastar para duplicar",
	"modifier_actions.uniform_scaling": "Escalado uniforme",
	"modifier_actions.snap_direction": "Quebrar la dirección",
	"message.no_valid_elements": "Los elementos seleccionados no son válidos",
	"dialog.add_primitive.shape.plane": "Plano",
	"dialog.save_angle.rotation_mode": "Modo de rotación",
	"dialog.save_angle.rotation": "Rotación",
	"dialog.save_angle.fov": "Campo de visión",
	"settings.hide_tab_bar": "Auto-ocultar la barra del Tabulador",
	"settings.hide_tab_bar.desc": "Ocultar la barra del Tabulador cuando un Tabulador es abierto",
	"settings.status_bar_modifier_keys": "Sugerir teclas modificadoras en la barra de estado",
	"settings.status_bar_modifier_keys.desc": "Mostrar teclas modificadoras sugeridas conscientes del contexto en la barra de estado",
	"settings.ground_plane": "Plano del suelo",
	"settings.ground_plane.desc": "Mostrar un segundo plano debajo del modelo",
	"settings.preview_paste_behavior": "Comportamiento de pegado de vista previa predeterminado",
	"settings.preview_paste_behavior.desc": "Selecciona el comportamiento al pegar algo en la vista previa en el modo de edición y hay múltiples opciones disponibles",
	"settings.preview_paste_behavior.always_ask": "Siempre responde",
	"action.new_window": "Nueva ventana",
	"action.new_window.desc": "Abrir una nueva ventana en Blockbench",
	"action.export_collada": "Exportar modelo Collada (dae)",
	"action.export_collada.desc": "Exportar modelo y animaciones como archivo dae para usarlo en otras aplicaciones 3D",
	"action.paint_mode_uv_overlay": "Cubrir UV",
	"action.paint_mode_uv_overlay.desc": "Muestra el mapa UV como una superposición en el modo de pintura",
	"action.bake_animation_into_model": "Hornear animación en modelo",
	"action.bake_animation_into_model.desc": "Hornea la animación mostrada actualmente al modelo. Solo aplica a la rotación y la posición, se ignora la escala.",
	"action.keyframe_interpolation.step": "Paso",
	"action.set_ik_target": "Fijar objetivo IK",
	"action.set_ik_target.desc": "Seleccione el hueso de destino que debe ser movido por este objeto nulo a través de cinemática inversa",
	"menu.action_control.type.tab": "Tabulador",
	"menu.action_control.type.angle": "Ángulo de cámara",
	"menu.action_control.recent_in_streamer_mode": "¿Seguro? El modo streamer está habilitado",
	"menu.action_control.recent_in_streamer_mode.desc": "¿Estás seguro de que quieres mostrar los modelos recientes?",
	"menu.tools": "Objetos",
	"menu.file.recent.more": "Ver más...",
	"menu.null_object.lock_ik_target_rotation": "Bloquear rotación IK",
	"menu.animation_file.import_remaining": "Importar animaciones restantes",
	"edit.loop_cut.offset": "Compensar",
	"edit.extrude_mesh_selection.extend": "Extender",
	"cube.color.pink": "Rosa",
	"cube.color.silver": "Gris claro",
	"dialog.plugins.offline": "Sin conexión a Internet",
	"dialog.create_texture.pixel_density": "Densidad del píxel",
	"dialog.create_texture.pixel_density.desc": "La densidad del píxel en la textura, en píxeles por metro. El tamaño del mapa de la textura puede diferenciar dependiendo de el tamaño y la cantidad de elementos",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "Nada",
	"panel.skin_pose.natural": "Naturar",
	"panel.skin_pose.walking": "Caminando",
	"panel.skin_pose.crouching": "Acechando",
	"panel.skin_pose.sitting": "Sentado",
	"panel.skin_pose.jumping": "Saltando",
	"panel.skin_pose.aiming": "Apuntando",
	"edit.loop_cut.direction": "Dirección",
	"data.texture_mesh": "Malla de textura",
	"generic.left": "Izquierda",
	"generic.right": "Derecha",
	"mode.start.quick_setup": "Armado rápido",
	"mode.start.keymap": "Keymap",
	"mode.start.quick_setup.more_themes": "Más...",
	"dialog.resize_texture.animation_frames": "Fotograma de animación",
	"dialog.export_emission_map.title": "Exportar Emission Map",
	"dialog.export_emission_map.format": "Formato",
	"dialog.export_emission_map.format.luminance": "Luminiscencia",
	"dialog.export_emission_map.format.luminance_inverted": "Luminiscencia invertida",
	"dialog.export_emission_map.format.colors": "Colores",
	"dialog.export_emission_map.threshold": "Transparency Threshold",
	"dialog.export_emission_map.round_up": "Round Up to %0 x %1",
	"dialog.export_emission_map.flip_y": "Invertir Eje Y",
	"dialog.select.type": "Tipo de elemento",
	"dialog.create_texture.max_edge_angle": "Edge Angle Threshold",
	"dialog.create_texture.max_edge_angle.desc": "The maximum angle between two faces at which they will still be combined",
	"dialog.create_texture.max_island_angle": "Island Angle Threshold",
	"dialog.create_texture.max_island_angle.desc": "The maximum angle that can be combined into the same UV island",
	"settings.mobile_panel_side": "Panel lateral móvil",
	"settings.mobile_panel_side.desc": "Select which side of the screen panels are displayed on when using Blockbench on in landscape orientation",
	"settings.obj_face_export_mode": "OBJ Face Export Mode",
	"settings.obj_face_export_mode.desc": "Choose to let the OBJ exporter convert all faces into tris or quads",
	"settings.obj_face_export_mode.both": "Por Defecto",
	"settings.obj_face_export_mode.tris": "Convert to Tris",
	"settings.obj_face_export_mode.quads": "Convert to Quads",
	"action.seam_tool": "Seam Tool",
	"action.seam_tool.desc": "Tool to define UV seams on mesh edges",
	"action.resolve_group": "Resolve Group",
	"action.resolve_group.desc": "Resolve the group while retaining its children in the same place",
	"action.move_to_group": "Mover a Grupo",
	"action.move_to_group.desc": "Mueve los elementos seleccionados a un grupo diferente",
	"action.select_seam": "Select UV Seam",
	"action.select_seam.desc": "Select the UV seam mode for the selected edges",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Unir",
	"action.select_seam.divide": "Dividir",
	"action.adjust_brightness_contrast": "Ajustar Brillo y Contraste",
	"action.adjust_brightness_contrast.desc": "Ajusta el brillo y contraste de la textura seleccionada",
	"action.adjust_saturation_hue": "Ajustar saturación y hue...",
	"action.adjust_saturation_hue.desc": "Ajustar la saturación y el hue de la textura seleccionada",
	"action.invert_colors": "Invertir Colores",
	"action.invert_colors.desc": "Invertir todos los colores de la textura seleccionada",
	"action.adjust_curves": "Ajustar curvas...",
	"action.adjust_curves.desc": "Ajustar las curvas de brillo de la textura seleccionada",
	"action.flip_texture_x": "Invertir Textura Horizontalmente",
	"action.flip_texture_y": "Invertir Textura Verticalmente",
	"action.resize_texture": "Reescalar Textura...",
	"action.view_mode.uv": "UV Preview",
	"action.append_to_template": "Añadir elementos a la plantilla...",
	"action.append_to_template.desc": "Añadir los elementos actualmente seleccionados a la plantilla de textura",
	"action.move_texture_with_uv": "Mover textura con UV",
	"action.move_texture_with_uv.desc": "Mueve la textura de la cara al arrastrar las caras UV",
	"action.timeline_setups": "Configuraciones de Líneas de Tiempo",
	"action.save_timeline_setup": "Guardar Configuración de la Línea de Tiempo...",
	"action.save_timeline_setup.desc": "Guarda una plantilla de los animadores y canales seleccionados",
	"menu.texture": "Textura",
	"menu.texture.render_mode.default": "Por Defecto",
	"menu.texture.merge_onto_texture": "Combinar con la Textura Encima",
	"menu.animation.unload": "Descargar",
	"panel.timeline": "Línea de Tiempo",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Tool to navigate in the viewport and the texture editor",
	"mode.start.recent.favorite": "Señalar como Favorito",
	"mode.start.info": "Información",
	"mode.start.target": "Objetivo",
	"mode.start.start": "Iniciar",
	"mode.start.create_new": "Crear Nuevo Modelo",
	"mode.start.format.informations": "Importante:",
	"mode.start.format.resources": "Recursos:",
	"format.free.info.meshes": "En este formato, puedes crear modelos low poly usando cubos y mallas con formas personalizadas.",
	"format.free.info.limitation": "Estos modelos no pueden ser usados en juegos que requieran formatos especializados, como Minecraft.",
	"format.skin.info.skin": "Este formato está diseñado para crear skins de Minecraft y texturas para entidades.",
	"format.skin.info.model": "Estos modelos no pueden ser modificados. Para realizar cambios, primero convierta a un formato diferente con **Archivo** > **Convertir Projecto**.",
	"format.java_block.info.rotation": "Las rotaciones están limitadas a incrementos de 22.5 grados y a solo un eje por cada elemento",
	"format.java_block.info.size": "El modelo está limitado a un tamaño de 3 por3 por 3 bloques. Sin embargo, los ajustes de visualización pueden hacer que los items parezcan más grandes",
	"format.java_block.info.animation": "Este formato no admite animaciones en Minecraft vanilla. Si estas creando un mod, puedes usar Geckolib para animar modelos. Si no, la única manera de animar es intercambiar el modelo usando comandos o texturas animadas.",
	"format.bedrock.info.textures": "Cada modelo solo puede usar una textura",
	"format.bedrock_block": "Bloque de Bedrock",
	"format.bedrock_block.desc": "Modelo de Bloque para Minecraft Bedrock",
	"format.modded_entity.info.integer_size": "El tamaño de cubos esta limitado a integrales.",
	"format.modded_entity.info.format": "Los modelos son escritos en código java en vez de estructuras de datos como el resto de formatos de exportación de Blockbench.",
	"format.optifine_entity.info.optifine_required": "Usuarios sin OptiFine instalado no podrán ver el modelo.",
	"format.optifine_entity.info.pivots": "Los pivotes de los huesos están bloqueados, es buena idea dejarlos sin modificar.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Otros",
	"format_category.loaders": "Cargadores",
	"message.recover_backup.recover": "Recuperar",
	"message.invalid_characters.title": "Trayectoria invalida",
	"message.invalid_characters.message": "La ruta del archivo importado contiene caracteres inválidos, letras mayúsculas, o espacios. Los caracteres permitidos son: %0",
	"dialog.share_model.thumbnail": "Miniatura",
	"dialog.skin.high_res_texture": "Please note that skins with the selected resolution will not work as regular Minecraft skins. Select a lower resolution.",
	"settings.allow_display_slot_mirror": "Allow Display Slot Mirroring",
	"settings.allow_display_slot_mirror.desc": "Allow Display slots for Java item models to be mirrored. WARNING: This only works in Minecraft 1.14 or earlier or in special cases.",
	"action.switch_tabs": "Intercambiar pestañas",
	"action.switch_tabs.desc": "Cycle between opened tabs. Hold shift to cycle in the opposite direction.",
	"action.unselect_all": "Deseleccionar todo",
	"action.unselect_all.desc": "Unselect all elements, faces, vertices, or keyframes",
	"action.save_palette": "Guardar Paleta...",
	"action.save_palette.desc": "Guarda la paleta de colores actual dentro de Blockbench para uso posterior",
	"action.keyframe_column_create": "Create Keyframe Column",
	"action.keyframe_column_create.desc": "Key all channels in the timeline at the current timecode, if they already have keyframes",
	"action.keyframe_column_select": "Select Keyframe Column",
	"action.keyframe_column_select.desc": "Select all keyframes in the timeline along a column below the playhead",
	"menu.uv": "UV",
	"menu.keyframe": "Fotogramas",
	"menu.palette.load.update": "Actualizar Paleta",
	"menu.palette.load.update.desc": "Actualiza esta paleta con los colores de la paleta actual de Blockbench",
	"menu.timeline_marker.set_time": "Set Time...",
	"uv_editor.scale_uv": "Reescalar UV",
	"action.preview_scene": "Escenario",
	"action.preview_scene.desc": "Cambia el escenario del modelo",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Invertir Eje Y",
	"preview_scene.studio": "Estudio",
	"format.image": "Image",
	"modifier_actions.set_copy_source": "Set Copy Source",
	"message.load_images.title": "Load Images",
	"message.load_images.edit_image": "Editar Imagen",
	"dialog.add_primitive.align_edges": "Align Edges",
	"dialog.flip_animation.show_in_timeline": "Muestra todos los huesos modificados en la línea de tiempo",
	"settings.default_cube_size": "Tamaño del Cubo",
	"settings.default_cube_size.desc": "Cambia el tamaño predeterminado del cubo al crear un nuevo cubo",
	"settings.uniform_keyframe": "Reescalar Fotogramas Uniformemente",
	"settings.uniform_keyframe.desc": "Establece los fotogramas clave a reescalado uniforme por defecto",
	"settings.nearest_rectangle_select": "Selección de rectángulo: Borde mas cercano",
	"settings.nearest_rectangle_select.desc": "Snap rectangle selections to the nearest pixel edge, like in GIMP, instead of entire pixels.",
	"settings.pick_color_opacity": "Seleccionar Opacidad del Color",
	"settings.pick_color_opacity.desc": "Selecciona la Opacidad del color con el Seleccionador de Color y la establece como la opacidad del pincel",
	"settings.paint_with_stylus_only": "Pintar con Lápiz",
	"settings.paint_with_stylus_only.desc": "Usa solo el lápiz para pintar, guarda el mouse o entrada táctil para la navegación",
	"action.copy_brush_mode": "Modo de Pincel de Copia",
	"action.copy_brush_mode.copy": "Copia",
	"action.copy_brush_mode.pattern": "Patrón",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_shape": "Forma del Pincel",
	"action.brush_shape.square": "Cuadrado",
	"action.brush_shape.circle": "Circulo",
	"action.blend_mode": "Modo de Combinación",
	"action.blend_mode.default": "Por Defecto",
	"action.blend_mode.set_opacity": "Establecer Opacidad",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Por Detrás",
	"action.blend_mode.multiply": "Multiplicar",
	"action.blend_mode.divide": "Dividir",
	"action.blend_mode.add": "Añadir",
	"action.blend_mode.subtract": "Restar",
	"action.blend_mode.screen": "Pantalla",
	"action.blend_mode.overlay": "Cubierta",
	"action.blend_mode.hard_light": "Hard Light",
	"action.blend_mode.difference": "Diferencia",
	"action.copy_brush": "Pincel de Copia",
	"action.copy_brush.desc": "Pincel para clonar partes de tu textura o dibujar patrones",
	"action.validator_window": "Ver Problemas del Modelo...",
	"action.validator_window.desc": "Abre el validador, que lista los problemas con el modelo actual.",
	"action.cancel_gif": "Cancelar Grabación",
	"menu.text_edit.copy_vector": "Copiar Vector",
	"menu.brush_presets.dialog": "Pinceles Predeterminados...",
	"menu.brush_presets.pixel_brush": "Pincel de Pixel",
	"menu.brush_presets.smooth_brush": "Pincel Suave",
	"menu.texture.edit_in_blockbench": "Editar en Blockbench",
	"menu.mirror_painting.axis": "Eje",
	"menu.mirror_painting.axis.desc": "Selecciona el eje en el que los trazos de pintura se invierten",
	"menu.mirror_painting.global": "Simetría Global",
	"menu.mirror_painting.global.desc": "Activa la inversión de pintura en el espacio global del modelo",
	"menu.mirror_painting.local": "Simetría Local",
	"menu.mirror_painting.local.desc": "Activa la inversión de pintura en el espacio local de cada elemento",
	"menu.mirror_painting.texture_frames": "Fotogramas de Texturas Animadas",
	"menu.mirror_painting.texture_frames.desc": "Invierte los trazos de pintura a cada fotograma de texturas animadas",
	"format.bedrock_block.info.size_limit": "Size total size of a block is limited to 30 pixels in all dimensions. The limit can be off-centered in all directions by 7 pixels from the block center.",
	"format.bedrock_block.info.textures": "Multiple textures can be applied to different cubes in Blockbench, but require additional setup in the behavior pack to work correctly in-game.",
	"format.image.desc": "Edit images in the 2D image editor",
	"generic.delete_all": "Eliminar todo",
	"message.child_model_only.open": "Open Parent",
	"message.child_model_only.open_with_textures": "Open Parent & Adopt Textures",
	"dialog.project.credit": "Credito",
	"dialog.convert_project.create_copy": "Crear copia",
	"dialog.texture.frame_time": "Frame Time",
	"dialog.texture.frame_time.desc": "Set for how long each frame will be visible, in ticks. Each tick is 1/20th of a second.",
	"dialog.texture.frame_interpolate": "Interpolar",
	"dialog.texture.frame_interpolate.desc": "Interpolate between animation frames by cross-fading to the next frame",
	"dialog.texture.frame_order_type": "Loop Mode",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop Backwards",
	"dialog.texture.frame_order_type.back_and_forth": "Back-and-Forth",
	"dialog.texture.frame_order_type.custom": "Custom Order",
	"dialog.texture.frame_order": "Frame Order",
	"dialog.texture.frame_order.desc": "Set a custom frame order by listing frame indices in a new order. Frame indices start at 0 with the first frame.",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "New Selection",
	"dialog.select.mode.add": "Add to Selected",
	"dialog.select.mode.remove": "Remove from Selected",
	"dialog.select.mode.in_selection": "Select only from Selected",
	"dialog.predicate_overrides.model": "Modelo",
	"dialog.predicate_overrides.predicates": "Predicates",
	"dialog.predicate_overrides.variants": "Variantes",
	"dialog.predicate_overrides.start_value": "Inicio",
	"dialog.predicate_overrides.add_override": "Add Override",
	"dialog.predicate_overrides.add_predicate": "Add Predicate",
	"dialog.predicate_overrides.generate_overrides": "Generate Overrides",
	"dialog.predicate_overrides.confirm_delete": "Are you sure you want to delete all overrides?",
	"dialog.predicate_overrides.predicate.angle": "Angulo de la brújula",
	"dialog.predicate_overrides.predicate.blocking": "Esta bloqueando",
	"dialog.predicate_overrides.predicate.broken": "Esta roto",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Enfriamiento",
	"dialog.predicate_overrides.predicate.damage": "Daño",
	"dialog.predicate_overrides.predicate.damaged": "Esta dañado",
	"dialog.predicate_overrides.predicate.lefthanded": "Es zurdo",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Esta cargado",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Light Level",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"action.export_fbx": "Export FBX Model",
	"action.export_fbx.desc": "Export model and animations as fbx file to use it in other 3D applications and game engines",
	"action.center_lateral": "Centro lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.adjust_opacity": "Ajustar opacidad",
	"action.adjust_opacity.desc": "Ajustar la opacidad de la textura seleccionada",
	"action.rotate_texture_cw": "Rotar en sentido del reloj",
	"action.rotate_texture_ccw": "Rotar en sentido contra reloj",
	"action.predicate_overrides": "Edit Predicate Overrides...",
	"action.predicate_overrides.desc": "Select models to override this model based on selected conditions",
	"action.auto_set_cullfaces": "Set Cullfaces Automatically",
	"action.auto_set_cullfaces.desc": "Automatically generate cullfaces to hide faces when they are covered by the neighboring block.",
	"menu.texture.edit_externally": "Editar externamente",
	"menu.mirror_painting.texture": "Simetría del editor 2D",
	"menu.mirror_painting.texture.desc": "Activar el pintado reflejado en el espacio 2D en la imagen o textura",
	"menu.animator.rotation_global": "Rotate in Global Space",
	"uv_editor.face_properties": "Propiedades de la cara",
	"uv_editor.face_properties.material_instance": "Instancia material",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "Enabling cullface tells a face on a block to unrender if another full block is placed next to it in the specified direction in your Minecraft world. This can be used to optimize performance.",
	"uv_editor.material_instance.info": "Material instances can be set to a user-defined name. That name can be used in the block JSON file in the behavior pack to assign a particular texture and material that the face.",
	"display.reference.frame_invisible": "Item Frame (Invisible)",
	"data.settings_profile": "Profile",
	"message.display_skin.invalid_name": "Cannot find Minecraft account with the name \"%0\".",
	"dialog.load_plugins_from_query.title": "Load Plugins",
	"dialog.load_plugins_from_query.text": "You used a link that requires plugins to be installed. Would you like to install them?",
	"dialog.select_model.title": "Select Model",
	"dialog.select_model.bones": "Bones",
	"dialog.select_model.cubes": "Cubes",
	"dialog.settings.create_profile": "Create Profile...",
	"settings_profile.confirm_delete": "Are you sure you want to delete this settings profile?",
	"settings_profile.condition.type.selectable": "Manually Selectable",
	"settings.interface_mode": "UI Mode",
	"settings.interface_mode.desc": "Interface mode",
	"settings.interface_mode.auto": "Automatic",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobile",
	"settings.paint_through_transparency": "Paint Through Transparency",
	"settings.paint_through_transparency.desc": "Paint through transparent pixels when Lock Alpha Channel is enabled",
	"action.tab_overview": "Tab Overview",
	"action.tab_overview.desc": "View all open tabs in a grid and jump to one",
	"action.slider_color_red": "Color Red",
	"action.slider_color_green": "Color Green",
	"action.slider_color_blue": "Color Blue",
	"action.add_animation_controller": "Add Animation Controller",
	"action.add_animation_controller.desc": "Create a blank animation controller",
	"action.animation_controller_preview_mode": "Controller Preview",
	"action.animation_controller_preview_mode.paused": "Paused",
	"action.animation_controller_preview_mode.manual": "Manual Preview",
	"action.animation_controller_preview_mode.play": "Auto Play",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Link Bézier Handles",
	"action.keyframe_bezier_linked.desc": "Connect the right and left keyframe bézier handle",
	"action.reset_keyframe_handles": "Reset Keyframe Handles",
	"action.reset_keyframe_handles.desc": "Reset the bézier handles of the selected keyframes",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Preview animations in an infinite loop",
	"timeline.bind_to_actor": "Bind to Actor",
	"animation_controllers.select_preset": "Select a controller preset...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particles",
	"animation_controllers.state.sounds": "Sounds",
	"animation_controllers.state.on_entry": "On Entry",
	"animation_controllers.state.on_exit": "On Exit",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Blend Time",
	"animation_controllers.state.shortest_path": "Blend by Shortest Path",
	"animation_controllers.state.edit_transition": "Edit Transition",
	"menu.color_picker.picker_type": "Picker Type",
	"menu.color_picker.picker_type.square": "Square",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.slider_mode": "Slider Mode",
	"menu.color_picker.slider_mode.hsv": "Hue, Saturation, Value",
	"menu.color_picker.slider_mode.rgb": "Red, Green, Blue",
	"menu.texture.render_mode.additive": "Additive",
	"panel.color.picker_options": "Color Picker Options",
	"panel.animation_controllers": "Animation Controller",
	"display.preset.armor_stand": "Ground (Armor Stand)",
	"data.file_path": "File Path",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Upright",
	"dialog.extrude.orientation.flat": "Flat",
	"dialog.scale.box_uv_warning": "Scaling a Box UV model may break the UV of your model. Instead, try to scale your model externally, or switch to Per-face UV Mode in File > Project.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequence",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Background Image",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.file_path.desc": "Use Regular Expression syntax to match the file path of the current project. Use forward slashes for directories",
	"settings.only_selected_bezier_handles": "Show Only Selected Bézier Handles",
	"settings.only_selected_bezier_handles.desc": "Hide handles of bézier keyframes that are not currently selected",
	"settings.embed_textures": "Embed Textures",
	"settings.embed_textures.desc": "Embed texture file content in .bbmodel files",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copied to clipboard",
	"data.reference_image": "Reference Image",
	"message.delete_reference_image": "Are you sure you want to delete this reference image? This cannot be undone.",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.add_reference_image.project": "Add to this project",
	"message.add_reference_image.app": "Add to all projects",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Both",
	"message.display_skin.username": "Username (Java)",
	"message.palette_locked": "The palette is locked",
	"dialog.project.default_uv_mode": "Default UV Mode",
	"dialog.project.default_uv_mode.description": "Default UV Mode of the project. The UV mode can also be changed per cube.",
	"dialog.export_options.title": "Export Options",
	"dialog.edit_texture.preview": "Preview",
	"dialog.proportional_editing.range": "Range",
	"dialog.proportional_editing.falloff": "Falloff",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Smooth",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selection",
	"dialog.proportional_editing.selection.linear": "Linear Distance",
	"dialog.proportional_editing.selection.connections": "Connections",
	"dialog.mirror_painting_texture_center.middle": "Middle",
	"dialog.mirror_painting_texture_center.custom": "Custom",
	"dialog.settings.reset_to_default": "Reset to Default",
	"keybindings.item.num_slider.increase": "Increase",
	"keybindings.item.num_slider.decrease": "Decrease",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"action.slider_palette_color": "Switch Palette Color",
	"action.slider_palette_color.desc": "Cycle between the colors in the palette",
	"action.proportional_editing": "Proportional Editing",
	"action.proportional_editing.desc": "Proportionally affect surrounding vertices when editing parts of a mesh",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Limits the colors of the texture to those in the currently loaded palette",
	"action.edit_reference_images": "Edit Reference Images",
	"action.edit_reference_images.desc": "Turn on reference image mode to add or edit reference images and blueprints",
	"action.add_reference_image": "Add Reference Image",
	"action.reference_image_from_clipboard": "Reference Image from Clipboard",
	"action.reference_image_list": "Reference Images",
	"action.connect_uv_faces": "Connect UV Faces",
	"action.connect_uv_faces.desc": "Connect the selected UV faces to the last selected UV face",
	"action.merge_uv_vertices": "Merge UV Vertices",
	"action.merge_uv_vertices.desc": "Snap the first selected UV vertices to the last selected UV vertices",
	"action.bedrock_animation_mode": "Bedrock Animation Mode",
	"action.bedrock_animation_mode.desc": "Select the mode to edit animations for Minecraft: Bedrock Edition in",
	"action.bedrock_animation_mode.entity": "Entity",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"timeline.amplify": "Amplify",
	"menu.options": "Options...",
	"menu.palette.lock_palette": "Lock Palette",
	"menu.uv.export": "Export UV Mapping",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.mirror_painting.enabled": "Enabled",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacity",
	"reference_image.visibility": "Visibility",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.layer.blueprint": "Locked Blueprint",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"codec.common.encoding": "Encoding",
	"codec.common.armature": "Export Groups as Armature",
	"codec.common.export_animations": "Export Animations",
	"codec.common.embed_textures": "Embed Textures",
	"preview.center_camera": "Center Camera",
	"display.reference.frame_top": "Item Frame Top",
	"display.reference.frame_top_invisible": "Item Frame Top (Invisible)",
	"action.proportional_editing_range": "Proportional Editing Range",
	"action.proportional_editing_range.desc": "Adjust the range for proportional editing",
	"action.toggle_all_reference_images": "Hide/Show All Reference Images",
	"action.toggle_all_reference_images.desc": "Toggle the visibility of all reference images at once",
	"action.add_animation_controller_state": "Add Animation Controller State",
	"action.add_animation_controller_state.desc": "Add a new state to the animation controller",
	"menu.slider.round_value": "Round Value",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"dialog.copy_to_clipboard": "Copy to clipboard",
	"dialog.open_url": "Open URL",
	"reference_image.image": "Image",
	"uv_editor.rotate_uv": "Rotate UV",
	"generic.error": "Error",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.dependencies": "Depends on:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map as an overlay in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Animation...",
	"action.animated_texture_editor.desc": "Setup or edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Emisión de luz",
	"action.cube_light_emission.desc": "Cambiar la emisividad de los cubos seleccionados, como un valor entre 0 y 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Solo rotación",
	"action.create_texture_group": "Crear grupo de texturas",
	"action.create_texture_group.desc": "Crear un grupo para tus texturas",
	"action.uv_maximize.all_faces": "Afecta todas las caras",
	"action.retarget_animators": "Reorientar animaciones",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Mezclar animación",
	"action.merge_animation.desc": "Mezclar la animación en otra animación",
	"action.add_keyframe.reset_values": "Con los valores por defecto",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Bordes reflejados",
	"menu.image_onion_skin_view.frame": "Fotogramas",
	"menu.image_onion_skin_view.frame.last_viewed": "Fotograma anteriormente visto",
	"menu.image_onion_skin_view.frame.previous": "Fotograma previo",
	"menu.image_onion_skin_view.frame.next": "Siguiente fotograma",
	"menu.image_onion_skin_view.frame.both": "Previo + anterior",
	"menu.image_onion_skin_view.display": "Mostrar",
	"menu.image_onion_skin_view.display.pixels": "Pixeles mas pequeños",
	"menu.image_onion_skin_view.display.transparent": "Transparente",
	"menu.image_onion_skin_view.above": "Mostrar abajo",
	"menu.animation.reload": "Recargar",
	"switches.autouv.alt": "Relativo",
	"display.rotation_pivot": "Eje de rotación",
	"display.scale_pivot": "Eje de escala",
	"display.reference.fox": "Zorro",
	"display.reference.eating": "Comer",
	"preview_scene.sky": "Cielo",
	"preview_scene.space": "Espacio",
	"preview_scene.minecraft_ocean": "Oceano",
	"message.import_palette.selection_only": "Solo selección",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generar...",
	"dialog.blend_transition_edit.generate.learn_more": "Mas info y vista previa",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "Limite de FPS",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reajustar vector",
	"dialog.blend_transition_edit.extended": "Grafico extendido",
	"message.screenshot_too_large.title": "Problema en la resolución de la captura",
	"message.screenshot_too_large.message": "La captura de pantalla no podrá renderizarse exitosamente. por favor inténtelo otra vez con una resolución mas baja o sin supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGB Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGB channel"
}